/* eslint-disable max-lines */
import gql from 'graphql-tag'
export const getPosts = gql`
  query($PK: String!, $SK: String, $title: String, $limit: Int, $nextToken: String) {
    listPosts(PK: $PK, SK: $SK, title: $title, limit: $limit, nextToken: $nextToken) {
      items {
        PK
        SK
        title
      }
    }
  }
`
export const getPreSignedURLImageUploadService = gql`
  query getPreSignedURLForImage($key: String!, $mimeType: String!, $type: String) {
    getPreSignedURLForImage(key: $key, mimeType: $mimeType, type: $type) {
      signedObject
      statusCode
    }
  }
`
export const listUsersInRoleService = gql`
  query listUsersInRole($roleName: String) {
    listUsersInRole(roleName: $roleName) {
      items {
        PK
        name
        handle
        userProfilePicURL
        jobRole
        creatorGrade
        VerificationStatus
      }
    }
  }
`
export const listHashTagsofUserAndGlobal = gql`
  query listHashTagsofUserAndGlobal($hashTag: String, $UUID: String) {
    listHashTagsofUserAndGlobal(hashTag: $hashTag, UUID: $UUID) {
      items {
        hashTag
        SK
        genderTarget
        wordPressTagID
      }
      nextToken
    }
  }
`
export const getYousayInAppUserService = gql`
  query($handle: String!) {
    getYousayInAppUser(handle: $handle) {
      statusCode
      statusMessage
      UUID
      name
    }
  }
`

export const getContentCategories = gql`
  query getContentCategories {
    getContentCategories {
      PK
      SK
      newsCategoryWPID
      targetAreaV2categoriesConfig {
        id
        heading
        wordPressCategoryID
        wordPressCategoryIDs
        parentArea
        addTargetArea
        addNews
        hideInCategoriesList
      }
      categoriesConfig {
        id
        heading
        addTargetArea
        addNews
        hideInCategoriesList
        wordPressCategoryID
        options {
          id
          heading
          addTargetArea
          addNews
          hideInCategoriesList
          wordPressCategoryID
          options {
            id
            heading
            addTargetArea
            addNews
            hideInCategoriesList
            wordPressCategoryID
            options {
              id
              heading
              addTargetArea
              addNews
              hideInCategoriesList
              wordPressCategoryID
            }
          }
        }
      }
    }
  }
`
export const getYouSayIDDetails = gql`
  query($YouSayID: String) {
    getYouSayIDDetails(YouSayID: $YouSayID) {
      PK
      SK
      creatorGrade
      creatorType
      gender
      handle
      ageGroup
      about
      mobileNumber
      name
      userProfilePicURL
      userProfilePicKey
      defaultLangIfContentInEnAndTe
      videoCreatorRequestStatus
      isOnBoarded
      onBoardStatus
      userProfileWalkThroughShown
      creatorProfileWalkThroughShown
      userAppLanguage
      interests
      userStatus
      defaultLanguageOfYourVideoContent
      instagramLink
      youtubeLink
      chosenSocialProfileForPromotion
      languages
      roles
      userRolesAndPermissions {
        roleName
        permissions {
          name
          selected
        }
      }
      appReviewTimes
      appReviewStatus
      appConfig {
        appReviewAfternDays
        appReviewAfternDaysGuest
      }
      appVersion
      appInstalledDate
      userAppStatus
      defaultVideoStatus
      privacyVersion
      termsVersion
      termsContent
      privacyContent
    }
  }
`

export const getContent = gql`
  query($appInfoFrontEnd: appInfoFrontEndInput, $contentID: String) {
    getContent(appInfoFrontEnd: $appInfoFrontEnd, contentID: $contentID) {
      syncToYousaytv
      addedTargetAreaCategories
      addedNewsCategories
      targetAreaCategoriesArr
      newsCategoriesArr
      wordPressInfo {
        wordPressCategoryIDs
        wordPressGalleryIDs
        wordPressMediaID
        wordPressID
        wordPressContentCategory1ID
        wordPressContentCategory2ID
        wordPressContentCategory3ID
        wordPressTagIDs
        wordPressPostURL
        wordPressPermaLink
        wordPressPostStatus
      }
      inAppMessageDetails {
        type
        description
        message
        yousayCreatorID
        imageURL
        videoID
        buttons
        repeat
        conditionType
        creatorVideosCount
        gender
        ageGroup
        creatorFollowersCount
        buttonText
        buttonIcon
        buttonBelowDescription
        buttonDestinationURL
        minimumDuration
        canCloseBeforeDurarion
        trackObjective
        when
        noOfTimes
        showFor
        priority
        conditionalOperator
        socialPlatForm
        socialPlatFormSub
        targetImpressions
        targetClicks
        campaignStartDateTime
        campaignEndDateTime
        campaignType
        inHousePosition
        classifiedPostPosition
        campaignPosition
        campaignTargetImpressions
        campaignTargetImpressionsPerUser
      }
      isInAppMessage
      stickyPost
      stickyEndDateTime
      positionFromTop
      showSticky
      stickyTargetImpressions
      stickyInProgressDateTime
      pushRankUpTo
      pushRankTo
      isPushRankActive
      tempPositionFromTop
      peopleValues {
        peopleType
        peopleName
        peopleValue
        peopleCoverImage
      }
      sendPushNotification
      sendPNWithImage
      pnPriority
      bigTextTitle
      bigTextTitle_Te
      bigTextTitle_En
      bigTextTitle_Hi
      pnTitle
      pnTitle_Te
      pnTitle_En
      pnTitle_Hi
      pnDescription
      pnDescription_Te
      pnDescription_En
      pnDescription_Hi
      createdFrom

      contentID
      contentModifiedDateTime
      contentPublishedDateTime
      watchLinkOpenedCount
      notificationSentDateTime
      primaryCategory
      sentPNTo
      PNOpenedCount
      PK
      SK
      type
      contentType
      creatorVideoHashTag1
      creatorVideoHashTag2
      creatorVideoHashTag3
      creatorVideoHashTag4
      creatorVideoHashTag1AndType
      creatorVideoHashTag2AndType
      creatorVideoHashTag3AndType
      creatorVideoHashTag4AndType
      genderSpecific
      tagsWithGenderTarget
      contentLanguage
      contentLanguages
      approvedContentLanguages
      targetAreas
      targetAreaV2
      allowShare
      allowComments
      createInBoxOffice
      creatorUUID
      creatorName
      creatorHandle
      creatorJobRole
      creatorProfilePicURL
      creatorHandleWatermarkPath
      viewed
      points
      commentsCount
      sharedVideoCount
      linkOpenedCount
      contentMainCategory
      contentVersion
      contentCategory1
      contentCategory2
      contentCategory3
      createdAs
      contentPlanner
      scheduledDate
      scheduledDate_Te
      scheduledDate_En
      scheduledDate_Hi
      scheduledTime
      scheduledTime_Te
      scheduledTime_En
      scheduledTime_Hi
      archivalDate
      autoDeleteDate
      selectedAutoExpireDate
      selectedAutoDeleteDate
      matchKey
      storyType
      associationKey
      tournamentKey
      isLiveNewsContent
      contentMetaInfo {
        liveCricketDetails {
          liveCricketInfo
          liveCricketTitle_Te
          liveCricketTitle_Hi
          liveCricketTitle_En
          liveCricketDescription_Te
          liveCricketDescription_Hi
          liveCricketDescription_En
          liveCricketInfo
          liveCricketImages {
            path
            image
            copyRight
            copyRightText
            shareImage
          }
        }
        cricketPointsTableDetails {
          cricketPointsTableDescription_En
          cricketPointsTableDescription_Hi
          cricketPointsTableDescription_Te
          cricketPointsTableTitle_En
          cricketPointsTableTitle_Hi
          cricketPointsTableTitle_Te
          cricketPointsTableImages {
            path
            image
            copyRight
            copyRightText
            shareImage
          }
        }
        thumbnailURL
        contentImage
        slideShowDetails {
          slideShowTitle
          slideShowTitle_Te
          slideShowTitle_En
          slideShowTitle_Hi

          slideShowImage
          pages {
            pageType
            storyDetails {
              shortByteTemplateType
              readMoreLink
              showRating
              reviewRating
              storyTitle
              storyTitle_Te
              storyTitle_En
              storyTitle_Hi
              storyYoutubeImages {
                path
                image
                copyRight
                copyRightText
                shareImage
              }
              storyCardImages {
                path
                image
                copyRight
                copyRightText
                shareImage
              }
              storyCardDescription
              storyCardDescription_Te
              storyCardDescription_En
              storyCardDescription_Hi
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
            }
            coverStoryDetails {
              flipToStoryDetails {
                styleType
                coverStoryTitle
                coverStoryTitle_Te
                coverStoryTitle_En
                coverStoryTitle_Hi
                coverStoryCardDescription
                coverStoryCardDescription_Te
                coverStoryCardDescription_En
                coverStoryCardDescription_Hi
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }

                coverStoryImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                coverStoryCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                textColor
                backGroundTitle
                contentTitlePosition
                coverStoryVideoURL
                youtubeID
                youtubeVideoOrientation
                imageTemplate
                imageTemplateDescription
                imageTemplateKey
              }
              onlyCoverDetails {
                advancedOverlayStyles {
                  advancedOverlayStyleType
                  enableSeperator
                  overlayDescriptionBold
                  overlayDescriptionColor
                  overlayDescriptionFontSize
                  overlayPositionFromBottom
                  overlayTitleBold
                  overlayTitleColor
                  overlayTitleFontSize
                  overlayBgColor
                  seperatorColor
                }
                styleType
                coverStoryTitle
                coverStoryTitle_Te
                coverStoryTitle_En
                coverStoryTitle_Hi
                coverStoryCardDescription
                coverStoryCardDescription_Te
                coverStoryCardDescription_En
                coverStoryCardDescription_Hi
                textColor
                backGroundTitle
                contentTitlePosition
                coverStoryVideoURL
                youtubeID
                youtubeVideoOrientation
                imageTemplate
                imageTemplateDescription
                imageTemplateKey
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }

                coverStoryImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
              }
              inAppBrowserDetails {
                coverStoryTitle
                coverStoryTitle_Te
                coverStoryTitle_En
                coverStoryTitle_Hi
                coverStoryImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }

                link
                linkText
                textColor
                backGroundTitle
                contentTitlePosition
              }
              coverStoryType
            }
            mcqDetails {
              mcqTitle
              mcqTitle_Te
              mcqTitle_En
              mcqTitle_Hi
              explanationCardTitle
              explanationCardTitle_Te
              explanationCardTitle_En
              explanationCardTitle_Hi
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              mcqImages {
                path
                image
                copyRight
                copyRightText
                shareImage
              }
              mcqCardImages {
                path
                image
                copyRight
                copyRightText
                shareImage
              }
              answerExplanation
              answerExplanation_Te
              answerExplanation_En
              answerExplanation_Hi
              answersInfo {
                id
                answer
                answer_Te
                answer_En
                answer_Hi
                image
                correct
                ordering
                weight
                placeholder
              }
              textColor
            }
            pollDetails {
              pollBgColor
              pollImage {
                path
                image
                copyRight
                copyRightText
                shareImage
              }
              pollInfo {
                pollOptionID
                choice_Te
                choice_Hi
                choice_En
                votes
              }
              pollPositionFromTop
              selectedPollColor
              textColor
              pollTitle
              pollTitle_Te
              pollTitle_En
              pollTitle_Hi
              pollDescription
              pollDescription_Te
              pollDescription_En
              pollDescription_Hi
              pollOptions
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
            }
          }
        }

        storyDetails {
          shortByteTemplateType
          readMoreLink
          showRating
          reviewRating
          storyTitle
          storyTitle_Te
          storyTitle_En
          storyTitle_Hi
          storyYoutubeImages {
            path
            image
            copyRight
            copyRightText
            shareImage
          }
          storyCardImages {
            image
            copyRight
            copyRightText
            shareImage
          }
          coverStoryVideoURL
          youtubeID
          youtubeVideoOrientation
          imageTemplate
          imageTemplateDescription
          imageTemplateKey
          contentLinkDetails {
            watchType
            urlType
            instagramLink
            youtubeLink
            twitterLink
            websiteLink
          }
          contentNewLinkDetails {
            linkSubText
            linkAvatar
            category
            urlType
            linkText
            buttonPositionFromTop
            buttonPositionFromLeft
            markdownLabel
            pageLink
            pageInfo {
              PK
              SK
              pageValue
              pageTitle
              pageThumbnail
              pageDescription
              pageTargetArea
              pageCreatedDateTime
              pageModifiedDateTime
              pageLanguage
              pageSubscriptionStatus
              pageTemplate
            }
            peopleLink
            peopleInfo {
              PK
              SK
              peopleType
              peopleName
              peopleValue
              peopleCreatedDateTime
              peopleModifiedDateTime
              peopleCoverImage
              peopleProfileImage
            }
            listLink
            listInfo {
              PK
              SK
              listValue
              listName
              listName_Te
              listName_Hi
              listName_En
              listThumbnail
              listStatus
              listType
            }
            collectionLink
            collectionInfo {
              PK
              SK
              collectionType
              collectionName
              collectionValue
              collectionImage
              collectionCreatedDateTime
              collectionModifiedDateTime
            }
            videoLink
            contentLink
            playstoreLink
            appstoreLink
            saavnLink
            gaanaLink
            httpsLink
            buttonStyle
            buttonPosition
            tweetType
            facebookLink
            trackerLink
            watchType
            instagramLink
            youtubeLink
            twitterLink
            websiteLink
          }

          storyCardDescription
          storyCardDescription_Te
          storyCardDescription_En
          storyCardDescription_Hi
          coverStoryVideoURL
          youtubeID
          youtubeVideoOrientation
          imageTemplate
          imageTemplateDescription
          imageTemplateKey
        }
        coverStoryDetails {
          flipToStoryDetails {
            styleType

            coverStoryTitle
            coverStoryTitle_Te
            coverStoryTitle_En
            coverStoryTitle_Hi
            coverStoryCardDescription
            coverStoryCardDescription_Te
            coverStoryCardDescription_En
            coverStoryCardDescription_Hi
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            coverStoryImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            coverStoryCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            textColor
            backGroundTitle
            contentTitlePosition
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          onlyCoverDetails {
            advancedOverlayStyles {
              advancedOverlayStyleType
              enableSeperator
              overlayDescriptionBold
              overlayDescriptionColor
              overlayDescriptionFontSize
              overlayPositionFromBottom
              overlayTitleBold
              overlayTitleColor
              overlayTitleFontSize
              overlayBgColor
              seperatorColor
            }
            styleType
            coverStoryTitle
            coverStoryTitle_Te
            coverStoryTitle_En
            coverStoryTitle_Hi
            coverStoryCardDescription
            coverStoryCardDescription_Te
            coverStoryCardDescription_En
            coverStoryCardDescription_Hi
            textColor
            backGroundTitle
            contentTitlePosition
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            coverStoryImages {
              image
              copyRight
              copyRightText
              shareImage
            }
          }
          inAppBrowserDetails {
            coverStoryTitle
            coverStoryTitle_Te
            coverStoryTitle_En
            coverStoryTitle_Hi
            coverStoryImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            link
            linkText
            textColor
            backGroundTitle
            contentTitlePosition
          }
          coverStoryType
        }
        mcqDetails {
          mcqTitle
          mcqTitle_Te
          mcqTitle_En
          mcqTitle_Hi
          explanationCardTitle
          explanationCardTitle_Te
          explanationCardTitle_En
          explanationCardTitle_Hi
          contentLinkDetails {
            watchType
            urlType
            instagramLink
            youtubeLink
            twitterLink
            websiteLink
          }
          contentNewLinkDetails {
            linkSubText
            linkAvatar
            category
            urlType
            linkText
            buttonPositionFromTop
            buttonPositionFromLeft
            markdownLabel
            pageLink
            pageInfo {
              PK
              SK
              pageValue
              pageTitle
              pageThumbnail
              pageDescription
              pageTargetArea
              pageCreatedDateTime
              pageModifiedDateTime
              pageLanguage
              pageSubscriptionStatus
              pageTemplate
            }
            peopleLink
            peopleInfo {
              PK
              SK
              peopleType
              peopleName
              peopleValue
              peopleCreatedDateTime
              peopleModifiedDateTime
              peopleCoverImage
              peopleProfileImage
            }
            listLink
            listInfo {
              PK
              SK
              listValue
              listName
              listName_Te
              listName_Hi
              listName_En
              listThumbnail
              listStatus
              listType
            }
            collectionLink
            collectionInfo {
              PK
              SK
              collectionType
              collectionName
              collectionValue
              collectionImage
              collectionCreatedDateTime
              collectionModifiedDateTime
            }
            videoLink
            contentLink
            playstoreLink
            appstoreLink
            saavnLink
            gaanaLink
            httpsLink
            buttonStyle
            buttonPosition
            tweetType
            facebookLink
            trackerLink
            watchType
            instagramLink
            youtubeLink
            twitterLink
            websiteLink
          }

          mcqImages {
            image
            copyRight
            copyRightText
            shareImage
          }
          mcqCardImages {
            image
            copyRight
            copyRightText
            shareImage
          }
          answerExplanation
          answerExplanation_Te
          answerExplanation_En
          answerExplanation_Hi
          answersInfo {
            id
            answer
            answer_Te
            answer_En
            answer_Hi
            image
            correct
            ordering
            weight
            placeholder
          }
          textColor
        }
        pollDetails {
          pollBgColor
          pollImage {
            path
            image
            copyRight
            copyRightText
            shareImage
          }
          pollInfo {
            pollOptionID
            choice_Te
            choice_Hi
            choice_En
            votes
          }
          pollPositionFromTop
          selectedPollColor
          textColor

          pollTitle
          pollTitle_Te
          pollTitle_En
          pollTitle_Hi
          pollDescription
          pollDescription_Te
          pollDescription_En
          pollDescription_Hi
          pollOptions
          contentLinkDetails {
            watchType
            urlType
            instagramLink
            youtubeLink
            twitterLink
            websiteLink
          }
          contentNewLinkDetails {
            linkSubText
            linkAvatar
            category
            urlType
            linkText
            buttonPositionFromTop
            buttonPositionFromLeft
            markdownLabel
            pageLink
            pageInfo {
              PK
              SK
              pageValue
              pageTitle
              pageThumbnail
              pageDescription
              pageTargetArea
              pageCreatedDateTime
              pageModifiedDateTime
              pageLanguage
              pageSubscriptionStatus
              pageTemplate
            }
            peopleLink
            peopleInfo {
              PK
              SK
              peopleType
              peopleName
              peopleValue
              peopleCreatedDateTime
              peopleModifiedDateTime
              peopleCoverImage
              peopleProfileImage
            }
            listLink
            listInfo {
              PK
              SK
              listValue
              listName
              listName_Te
              listName_Hi
              listName_En
              listThumbnail
              listStatus
              listType
            }
            collectionLink
            collectionInfo {
              PK
              SK
              collectionType
              collectionName
              collectionValue
              collectionImage
              collectionCreatedDateTime
              collectionModifiedDateTime
            }
            videoLink
            contentLink
            playstoreLink
            appstoreLink
            saavnLink
            gaanaLink
            httpsLink
            buttonStyle
            buttonPosition
            tweetType
            facebookLink
            trackerLink
            watchType
            instagramLink
            youtubeLink
            twitterLink
            websiteLink
          }
        }
        jobDetails {
          workType
          workingHours
          workingDays
          positionID
          displayMobileNumberInJobPost
          jobApplicationLink
          GST
          readMoreLink
          jobSummary
          jobSector
          jobTitle
          jobDescription
          jobRole
          jobType
          minimumMonthlySalary
          maximumMonthlySalary
          minimumExperience
          maximumExperience
          jobMainLocation
          jobSubLocation
          startDate
          activeTillDate
          languages
          contactName
          contactEmail
          contactMobileNumber
          companyName
          companyBio
          companyRegisteredAddress
          jobImages {
            path
            image
            copyRight
            copyRightText
            shareImage
          }
          jobQualification
          experienceRange
          salaryRange
          jobCategory
          jobSkills
          jobTitle_Te
          jobTitle_En
          jobDescription_Te
          jobDescription_En
          noOfOpenings
          companyWebsite
        }
        liveNewsSectionDetails {
          readMoreLink
          showRating
          reviewRating
          liveNewsTitle
          liveNewsTitle_Te
          liveNewsTitle_En
          liveNewsTitle_Hi
          createdAs
          createdFrom
          createdDateTime
          modifiedBy
          modifiedDateTime
          liveNewsYoutubeImages {
            path
            image
            copyRight
            copyRightText
            shareImage
          }
          liveNewsImages {
            image
            copyRight
            copyRightText
            shareImage
          }
          liveNewsVideoURL
          liveNewsYoutubeID
          youtubeID
          youtubeVideoOrientation
          imageTemplate
          imageTemplateDescription
          imageTemplateKey
          contentLinkDetails {
            watchType
            urlType
            instagramLink
            youtubeLink
            twitterLink
            websiteLink
          }
          contentNewLinkDetails {
            linkSubText
            linkAvatar
            category
            urlType
            linkText
            buttonPositionFromTop
            buttonPositionFromLeft
            markdownLabel
            pageLink
            pageInfo {
              PK
              SK
              pageValue
              pageTitle
              pageThumbnail
              pageDescription
              pageTargetArea
              pageCreatedDateTime
              pageModifiedDateTime
              pageLanguage
              pageSubscriptionStatus
              pageTemplate
            }
            peopleLink
            peopleInfo {
              PK
              SK
              peopleType
              peopleName
              peopleValue
              peopleCreatedDateTime
              peopleModifiedDateTime
              peopleCoverImage
              peopleProfileImage
            }
            listLink
            listInfo {
              PK
              SK
              listValue
              listName
              listName_Te
              listName_Hi
              listName_En
              listThumbnail
              listStatus
              listType
            }
            collectionLink
            collectionInfo {
              PK
              SK
              collectionType
              collectionName
              collectionValue
              collectionImage
              collectionCreatedDateTime
              collectionModifiedDateTime
            }
            videoLink
            contentLink
            playstoreLink
            appstoreLink
            saavnLink
            gaanaLink
            httpsLink
            buttonStyle
            buttonPosition
            tweetType
            facebookLink
            trackerLink
            watchType
            instagramLink
            youtubeLink
            twitterLink
            websiteLink
          }

          liveNewsDescription
          liveNewsDescription_Te
          liveNewsDescription_En
          liveNewsDescription_Hi
          liveNewsVideoURL
          liveNewsYoutubeID
          youtubeID
          youtubeVideoOrientation
          imageTemplate
          imageTemplateDescription
          imageTemplateKey
        }
        content
        questionHint
        contentImage
        questionType
        link
        linkText
        published
        explanation
        explanationImages

        userExplanation
        wrongAnswerText
        rightAnswerText
        createdDate
        answersInfo {
          correct
          ordering
          placeholder
          weight
          answer
          answer_Te
          answer_En
          answer_Hi
          image
        }
      }
    }
  }
`
export const searchJobs = gql`
  query(
    $search: String
    $from: Int
    $limit: Int
    $filterBy: String
    $jobRole: [String]
    $jobType: [String]
    $jobMainLocation: [String]
    $jobQualification: [String]
    $experienceRange: [String]
    $salaryRange: [String]
    $jobCategory: [String]
    $jobSkills: [String]
    $workType: [String]
    $jobSubLocation: [String]
    $sortBy: String
    $sortByOrder: String
  ) {
    searchJobs(
      search: $search
      from: $from
      limit: $limit
      filterBy: $filterBy
      jobRole: $jobRole
      jobType: $jobType
      jobMainLocation: $jobMainLocation
      jobQualification: $jobQualification
      experienceRange: $experienceRange
      salaryRange: $salaryRange
      jobCategory: $jobCategory
      jobSkills: $jobSkills
      workType: $workType
      jobSubLocation: $jobSubLocation
      sortBy: $sortBy
      sortByOrder: $sortByOrder
    ) {
      total
      items {
        PK
        SK
        contentMetaInfo {
          jobDetails {
            jobTitle
            jobDescription
            jobRole
            jobType
            minimumMonthlySalary
            maximumMonthlySalary
            minimumExperience
            maximumExperience
            jobMainLocation
            jobSubLocation

            jobSkills
            jobSubLocation
            startDate
            activeTillDate
            languages
            contactName
            contactEmail
            contactMobileNumber
            companyName
            companyBio
            companyRegisteredAddress
            jobImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            jobQualification
            experienceRange
            salaryRange
            GST
            jobApplicationLink
          }
        }
        contentPublishedDateTime
        contentCreatedDateTime
        originalCreatorName
      }
      nextToken
      filteredJobQualifications {
        key
        doc_count
      }
      filteredWorkTypes {
        key
        doc_count
      }
      filteredJobCategories {
        key
        doc_count
      }
      filteredJobSkills {
        key
        doc_count
      }
      filteredExperienceRange {
        key
        doc_count
      }
      filteredJobRoles {
        key
        doc_count
      }
      filteredJobSubLocations {
        key
        doc_count
      }
      filteredJobMainLocations {
        key
        doc_count
      }
      filteredSalaryRange {
        key
        doc_count
      }
      filteredJobTypes {
        key
        doc_count
      }
    }
  }
`
export const listJobs = gql`
  query listJobs($input: listJobsInput) {
    listJobs(input: $input) {
      items {
        PK
        SK
        redisTime
        contentPublishedDateTime
        contentCreatedDateTime
        originalCreatorName
        originalCreatorHandle
        contentLanguages
        contentLanguage
        sendPushNotification
        sendPNWithImage
        bigTextTitle
        bigTextTitle_Te
        bigTextTitle_En
        bigTextTitle_Hi
        pnTitle
        pnTitle_Te
        pnTitle_En
        pnTitle_Hi
        pnDescription
        pnDescription_Te
        pnDescription_En
        pnDescription_Hi

        contentMetaInfo {
          jobDetails {
            jobTitle
            jobTitle_Te
            jobTitle_En
            jobDescription
            jobDescription_Te
            jobDescription_En
            jobType
            jobMainLocation
            jobSubLocation
            jobSkills
            jobSubLocation
            startDate
            activeTillDate
            jobSummary
            jobSector
            languages
            contactName
            contactEmail
            companyWebsite
            contactMobileNumber
            companyName
            companyBio
            companyRegisteredAddress
            jobImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            jobQualification
            experienceRange
            salaryRange
            noOfOpenings
            GST
            jobApplicationLink
          }
        }
      }

      nextToken
    }
  }
`
export const listContents = gql`
  query(
    $limit: Int
    $nextToken: String
    $contentStatus: String
    $appInfoFrontEnd: appInfoFrontEndInput
    $fromTime: Int
    $toTime: Int
    $language: String
  ) {
    listContents(
      limit: $limit
      nextToken: $nextToken
      contentStatus: $contentStatus
      appInfoFrontEnd: $appInfoFrontEnd
      fromTime: $fromTime
      toTime: $toTime
      language: $language
    ) {
      items {
        originalCreatorName
        originalCreatorHandle
        syncToYousaytv
        addedTargetAreaCategories
        addedNewsCategories
        targetAreaCategoriesArr
        newsCategoriesArr
        wordPressInfo {
          wordPressCategoryIDs
          wordPressGalleryIDs
          wordPressMediaID
          wordPressID
          wordPressContentCategory1ID
          wordPressContentCategory2ID
          wordPressContentCategory3ID
          wordPressTagIDs
          wordPressPostURL
          wordPressPermaLink
          wordPressPostStatus
        }
        polledCount
        isInAppMessage
        inAppMessageDetails {
          type
          description
          message
          yousayCreatorID
          imageURL
          videoID
          buttons
          repeat
          conditionType
          creatorVideosCount
          gender
          ageGroup
          creatorFollowersCount
          buttonText
          buttonIcon
          buttonBelowDescription
          buttonDestinationURL
          minimumDuration
          canCloseBeforeDurarion
          trackObjective
          when
          noOfTimes
          showFor
          priority
          conditionalOperator
          socialPlatForm
          socialPlatFormSub
          targetImpressions
          targetClicks
          campaignStartDateTime
          campaignEndDateTime
          campaignType
          inHousePosition
          classifiedPostPosition
          campaignPosition
          campaignTargetImpressions
          campaignTargetImpressionsPerUser
        }
        polledCount
        stickyPost
        stickyEndDateTime
        positionFromTop
        showSticky
        stickyTargetImpressions
        stickyInProgressDateTime
        pushRankUpTo
        pushRankTo
        isPushRankActive
        tempPositionFromTop
        archivedFromRedis
        pnPriority
        createdFrom
        approvedContentLanguages
        notificationSentDateTime
        isScheduled
        contentID
        contentCreatedDateTime
        contentModifiedDateTime
        contentPublishedDateTime
        PK
        SK
        type
        contentType
        contentVersion
        linkOpenedCount
        creatorVideoHashTag1
        creatorVideoHashTag2
        creatorVideoHashTag3
        creatorVideoHashTag4
        creatorVideoHashTag1AndType
        creatorVideoHashTag2AndType
        creatorVideoHashTag3AndType
        creatorVideoHashTag4AndType
        genderSpecific
        tagsWithGenderTarget
        contentLanguage
        contentLanguages
        approvedContentLanguages
        targetAreas
        targetAreaV2
        createInBoxOffice
        allowShare
        allowComments
        creatorUUID
        creatorName
        creatorHandle
        creatorJobRole
        creatorProfilePicURL
        creatorHandleWatermarkPath
        viewed
        likes
        points
        commentsCount
        sharedVideoCount
        contentMainCategory
        contentVersion
        contentCategory1
        contentCategory2
        contentCategory3
        createdAs
        contentPlanner
        scheduledDate
        scheduledDate_En
        scheduledDate_Te
        scheduledDate_Hi
        scheduledTime
        scheduledTime_En
        scheduledTime_Hi
        scheduledTime_Te
        archivalDate
        selectedAutoExpireDate
        selectedAutoDeleteDate
        sendPushNotification
        sendPNWithImage
        bigTextTitle
        bigTextTitle_Te
        bigTextTitle_En
        bigTextTitle_Hi
        pnTitle
        pnTitle_Te
        pnTitle_En
        pnTitle_Hi
        pnDescription
        pnDescription_Te
        pnDescription_En
        pnDescription_Hi
        peopleValues {
          peopleType
          peopleName
          peopleValue
          peopleCoverImage
        }
        matchKey
        storyType
        associationKey
        tournamentKey
        isLiveNewsContent
        contentMetaInfo {
          liveCricketDetails {
            liveCricketInfo
            liveCricketTitle_Te
            liveCricketTitle_Hi
            liveCricketTitle_En
            liveCricketDescription_Te
            liveCricketDescription_Hi
            liveCricketDescription_En
            liveCricketInfo
            liveCricketImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
          }
          cricketPointsTableDetails {
            cricketPointsTableDescription_En
            cricketPointsTableDescription_Hi
            cricketPointsTableDescription_Te
            cricketPointsTableTitle_En
            cricketPointsTableTitle_Hi
            cricketPointsTableTitle_Te
            cricketPointsTableImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
          }

          thumbnailURL
          contentImage
          slideShowDetails {
            autoSlideOn
            autoSlideSeconds

            slideShowTitle
            slideShowTitle_Te
            slideShowTitle_En
            slideShowTitle_Hi
            slideShowImage
            pages {
              pageType
              storyDetails {
                shortByteTemplateType
                readMoreLink
                showRating
                reviewRating
                storyTitle
                storyTitle_Te
                storyTitle_En
                storyTitle_Hi
                storyYoutubeImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardDescription
                storyCardDescription_Te
                storyCardDescription_En
                storyCardDescription_Hi
                coverStoryVideoURL
                youtubeID
                youtubeVideoOrientation
                imageTemplate
                imageTemplateDescription
                imageTemplateKey
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
              coverStoryDetails {
                flipToStoryDetails {
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  contentNewLinkDetails {
                    linkSubText
                    linkAvatar
                    category
                    urlType
                    linkText
                    buttonPositionFromTop
                    buttonPositionFromLeft
                    markdownLabel
                    pageLink
                    pageInfo {
                      PK
                      SK
                      pageValue
                      pageTitle
                      pageThumbnail
                      pageDescription
                      pageTargetArea
                      pageCreatedDateTime
                      pageModifiedDateTime
                      pageLanguage
                      pageSubscriptionStatus
                      pageTemplate
                    }
                    peopleLink
                    peopleInfo {
                      PK
                      SK
                      peopleType
                      peopleName
                      peopleValue
                      peopleCreatedDateTime
                      peopleModifiedDateTime
                      peopleCoverImage
                      peopleProfileImage
                    }
                    listLink
                    listInfo {
                      PK
                      SK
                      listValue
                      listName
                      listName_Te
                      listName_Hi
                      listName_En
                      listThumbnail
                      listStatus
                      listType
                    }
                    collectionLink
                    collectionInfo {
                      PK
                      SK
                      collectionType
                      collectionName
                      collectionValue
                      collectionImage
                      collectionCreatedDateTime
                      collectionModifiedDateTime
                    }
                    videoLink
                    contentLink
                    playstoreLink
                    appstoreLink
                    saavnLink
                    gaanaLink
                    httpsLink
                    buttonStyle
                    buttonPosition
                    tweetType
                    facebookLink
                    trackerLink
                    watchType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  coverStoryCardImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                }
                onlyCoverDetails {
                  advancedOverlayStyles {
                    advancedOverlayStyleType
                    enableSeperator
                    overlayDescriptionBold
                    overlayDescriptionColor
                    overlayDescriptionFontSize
                    overlayPositionFromBottom
                    overlayTitleBold
                    overlayTitleColor
                    overlayTitleFontSize
                    overlayBgColor
                    seperatorColor
                  }
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  contentNewLinkDetails {
                    linkSubText
                    linkAvatar
                    category
                    urlType
                    linkText
                    buttonPositionFromTop
                    buttonPositionFromLeft
                    markdownLabel
                    pageLink
                    pageInfo {
                      PK
                      SK
                      pageValue
                      pageTitle
                      pageThumbnail
                      pageDescription
                      pageTargetArea
                      pageCreatedDateTime
                      pageModifiedDateTime
                      pageLanguage
                      pageSubscriptionStatus
                      pageTemplate
                    }
                    peopleLink
                    peopleInfo {
                      PK
                      SK
                      peopleType
                      peopleName
                      peopleValue
                      peopleCreatedDateTime
                      peopleModifiedDateTime
                      peopleCoverImage
                      peopleProfileImage
                    }
                    listLink
                    listInfo {
                      PK
                      SK
                      listValue
                      listName
                      listName_Te
                      listName_Hi
                      listName_En
                      listThumbnail
                      listStatus
                      listType
                    }
                    collectionLink
                    collectionInfo {
                      PK
                      SK
                      collectionType
                      collectionName
                      collectionValue
                      collectionImage
                      collectionCreatedDateTime
                      collectionModifiedDateTime
                    }
                    videoLink
                    contentLink
                    playstoreLink
                    appstoreLink
                    saavnLink
                    gaanaLink
                    httpsLink
                    buttonStyle
                    buttonPosition
                    tweetType
                    facebookLink
                    trackerLink
                    watchType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                }
                inAppBrowserDetails {
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  contentNewLinkDetails {
                    linkSubText
                    linkAvatar
                    category
                    urlType
                    linkText
                    buttonPositionFromTop
                    buttonPositionFromLeft
                    markdownLabel
                    pageLink
                    pageInfo {
                      PK
                      SK
                      pageValue
                      pageTitle
                      pageThumbnail
                      pageDescription
                      pageTargetArea
                      pageCreatedDateTime
                      pageModifiedDateTime
                      pageLanguage
                      pageSubscriptionStatus
                      pageTemplate
                    }
                    peopleLink
                    peopleInfo {
                      PK
                      SK
                      peopleType
                      peopleName
                      peopleValue
                      peopleCreatedDateTime
                      peopleModifiedDateTime
                      peopleCoverImage
                      peopleProfileImage
                    }
                    listLink
                    listInfo {
                      PK
                      SK
                      listValue
                      listName
                      listName_Te
                      listName_Hi
                      listName_En
                      listThumbnail
                      listStatus
                      listType
                    }
                    collectionLink
                    collectionInfo {
                      PK
                      SK
                      collectionType
                      collectionName
                      collectionValue
                      collectionImage
                      collectionCreatedDateTime
                      collectionModifiedDateTime
                    }
                    videoLink
                    contentLink
                    playstoreLink
                    appstoreLink
                    saavnLink
                    gaanaLink
                    httpsLink
                    buttonStyle
                    buttonPosition
                    tweetType
                    facebookLink
                    trackerLink
                    watchType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  link
                  linkText
                  textColor
                  backGroundTitle
                  contentTitlePosition
                }
                coverStoryType
              }
              mcqDetails {
                mcqTitle
                mcqTitle_Te
                mcqTitle_En
                mcqTitle_Hi
                explanationCardTitle
                explanationCardTitle_Te
                explanationCardTitle_En
                explanationCardTitle_Hi
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }

                mcqImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                mcqCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                answerExplanation
                answerExplanation_Te
                answerExplanation_En
                answerExplanation_Hi
                answersInfo {
                  id
                  answer
                  answer_Te
                  answer_En
                  answer_Hi
                  image
                  correct
                  ordering
                  weight
                  placeholder
                }
                textColor
              }
              pollDetails {
                pollBgColor
                pollImage {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                pollInfo {
                  pollOptionID
                  choice_Te
                  choice_Hi
                  choice_En
                  votes
                }
                pollPositionFromTop
                selectedPollColor
                textColor
                pollTitle
                pollTitle_Te
                pollTitle_En
                pollTitle_Hi
                pollDescription
                pollDescription_Te
                pollDescription_En
                pollDescription_Hi
                pollOptions
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
            }
          }

          storyDetails {
            shortByteTemplateType
            readMoreLink
            showRating
            reviewRating
            storyTitle
            storyTitle_Te
            storyTitle_En
            storyTitle_Hi
            storyYoutubeImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            storyCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            storyCardDescription
            storyCardDescription_Te
            storyCardDescription_En
            storyCardDescription_Hi
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          coverStoryDetails {
            flipToStoryDetails {
              styleType
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              coverStoryCardImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
            }
            onlyCoverDetails {
              advancedOverlayStyles {
                advancedOverlayStyleType
                enableSeperator
                overlayDescriptionBold
                overlayDescriptionColor
                overlayDescriptionFontSize
                overlayPositionFromBottom
                overlayTitleBold
                overlayTitleColor
                overlayTitleFontSize
                overlayBgColor
                seperatorColor
              }
              styleType
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
            }
            inAppBrowserDetails {
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              link
              linkText
              textColor
              backGroundTitle
              contentTitlePosition
            }
            coverStoryType
          }
          mcqDetails {
            mcqTitle
            mcqTitle_Te
            mcqTitle_En
            mcqTitle_Hi
            explanationCardTitle
            explanationCardTitle_Te
            explanationCardTitle_En
            explanationCardTitle_Hi
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            mcqImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            mcqCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            answerExplanation
            answerExplanation_Te
            answerExplanation_En
            answerExplanation_Hi
            answersInfo {
              id
              answer
              answer_Te
              answer_En
              answer_Hi
              image
              correct
              ordering
              weight
              placeholder
            }
            textColor
          }
          pollDetails {
            pollBgColor
            pollImage {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            pollInfo {
              pollOptionID
              choice_Te
              choice_Hi
              choice_En
              votes
            }
            pollPositionFromTop
            selectedPollColor
            textColor
            pollTitle
            pollTitle_Te
            pollTitle_En
            pollTitle_Hi
            pollDescription
            pollDescription_Te
            pollDescription_En
            pollDescription_Hi
            pollOptions
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
          }
          jobDetails {
            workType
            workingHours
            workingDays
            positionID
            displayMobileNumberInJobPost
            jobApplicationLink
            readMoreLink
            jobTitle
            jobDescription
            jobRole
            jobType
            minimumMonthlySalary
            maximumMonthlySalary
            minimumExperience
            maximumExperience
            jobMainLocation
            jobSubLocation
            startDate
            activeTillDate
            languages
            contactName
            contactEmail
            contactMobileNumber
            companyName
            companyBio
            companyRegisteredAddress
            jobImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            jobQualification
            experienceRange
            salaryRange
            jobCategory
            jobSkills
            jobTitle_Te
            jobTitle_En
            jobDescription_Te
            jobDescription_En
            noOfOpenings
            companyWebsite
          }
          liveNewsSectionDetails {
            readMoreLink
            showRating
            reviewRating
            liveNewsTitle
            liveNewsTitle_Te
            liveNewsTitle_En
            liveNewsTitle_Hi
            createdAs
            createdFrom
            createdDateTime
            modifiedBy
            modifiedDateTime
            liveNewsYoutubeImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            liveNewsImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            liveNewsVideoURL
            liveNewsYoutubeID
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            liveNewsDescription
            liveNewsDescription_Te
            liveNewsDescription_En
            liveNewsDescription_Hi
            liveNewsVideoURL
            liveNewsYoutubeID
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          content
          questionHint
          contentImage
          questionType
          link
          linkText
          published
          explanation
          explanationImages

          userExplanation
          wrongAnswerText
          rightAnswerText
          createdDate
          answersInfo {
            correct
            ordering
            placeholder
            weight
            answer
            answer_Te
            answer_En
            answer_Hi
            image
          }
        }
      }
      nextToken
    }
  }
`
export const listPeople = gql`
  query listPeople($limit: Int, $search: String, $nextToken: String) {
    listPeople(limit: $limit, search: $search, nextToken: $nextToken) {
      items {
        PK
        SK
        peopleType
        peopleName
        peopleValue
        peopleCreatedDateTime
        peopleModifiedDateTime
        peopleCoverImage
        peopleProfileImage
      }
      nextToken
    }
  }
`

export const getPeopleDetails = gql`
  query getPeopleDetails($peopleValue: String) {
    getPeopleDetails(peopleValue: $peopleValue) {
      PK
      SK
      peopleType
      peopleName
      peopleValue
      peopleDescription
      peopleCoverImage
      peopleProfileImage
      peopleCreatedDateTime
      peopleModifiedDateTime
      peopleTemplate
    }
  }
`
export const listLists = gql`
  query listLists(
    $limit: Int
    $nextToken: String
    $contentID: String
    $type: String
    $videoID: String
    $search: String
    $appInfoFrontEnd: appInfoFrontEndInput
  ) {
    listLists(
      limit: $limit
      contentID: $contentID
      appInfoFrontEnd: $appInfoFrontEnd
      nextToken: $nextToken
      videoID: $videoID
      search: $search
      type: $type
    ) {
      items {
        PK
        SK
        listValue
        listName
        listName_Te
        listName_Hi
        listName_En
        listThumbnail
        listStatus
        listType
      }
      nextToken
      videoLists
      contentLists
    }
  }
`
export const listCollection = gql`
  query listCollection($limit: Int, $nextToken: String, $search: String) {
    listCollection(limit: $limit, nextToken: $nextToken, search: $search) {
      items {
        PK
        SK
        collectionType
        collectionName
        collectionValue
        collectionImage
        collectionCreatedDateTime
        collectionModifiedDateTime
      }
      nextToken
    }
  }
`
export const listPage = gql`
  query listPage($limit: Int, $nextToken: String, $search: String) {
    listPage(limit: $limit, nextToken: $nextToken, search: $search) {
      items {
        PK
        SK
        pageValue
        pageTitle
        pageThumbnail
        pageDescription
        pageTargetArea
        pageCreatedDateTime
        pageModifiedDateTime
        pageLanguage
        pageSubscriptionStatus
        pageTemplate
      }
      nextToken
    }
  }
`
export const getSections = gql`
  query getSections($PK: String, $limit: Int, $nextToken: String) {
    getSections(PK: $PK, limit: $limit, nextToken: $nextToken) {
      items {
        PK
        SK
        pageValue
        peopleValue
        listValue
        listName
        listName_Te
        listName_Hi
        listName_En
        collectionName
        collectionValue
        sectionLabel_Te
        sectionLabel_Hi
        sectionPosition
        sectionScroll
        sectionColumns
        sectionLabel_En
        sectionValue
        sectionColumns
        sectionConfigType
        sectionScroll
        showAsSubPage
        displayAfter
        sortBy
        GSIRecordType
      }
      nextToken
    }
  }
`
export const listTemplates = gql`
  query listTemplates($limit: Int, $templateType: String, $nextToken: String) {
    listTemplates(limit: $limit, templateType: $templateType, nextToken: $nextToken) {
      items {
        PK
        SK
        sections
        templateType
        templateName
        templateValue
        templateDescription
        templateCreatedDateTime
        templateModifiedDateTime
        GSITemplateTypeAndTime
        sectionsMasterData {
          PK
          SK
          pageValue
          pageTitle
          listValue
          listName_En
          listName_Te
          listName_Hi
          sectionLabel_Te
          sectionLabel_Hi
          sectionLabel_En
          collectionName
          collectionValue
          sectionColumns
          sectionConfigType
          sectionScroll
          showAsSubPage
          displayAfter
          sortBy
        }
      }
      nextToken
    }
  }
`
export const getSectionDataMasterDetails = gql`
  query getSectionDataMasterDetails($PK: String, $SK: String, $type: String) {
    getSectionDataMasterDetails(PK: $PK, SK: $SK, type: $type) {
      items {
        PK
        SK
        peopleType
        peopleName
        peopleValue
        peopleCoverImage
        peopleProfileImage
        pageValue
        pageTitle
        pageThumbnail
        pageDescription
        pageTargetArea
      }
    }
  }
`
export const getImageTemplatesQuery = gql`
  query getImageTemplates($imageTemplateContentType: String, $limit: Int, $nextToken: String) {
    getImageTemplates(
      imageTemplateContentType: $imageTemplateContentType
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        PK
        SK
        imageTemplateID
        imageTemplatePath
        imageTemplateHeading
        imageTemplateContentType
        imageTemplateCreatedDateTime
      }
      nextToken
    }
  }
`
export const getContentMainCategoryCounts = gql`
  query getContentMainCategoryCounts {
    getContentMainCategoryCounts {
      newsCount
      infoRegularCount
      infoImportantCount
      infoHighlightCount
    }
  }
`
export const listPushNotificationCounters = gql`
  query listPushNotificationCounters($filters: filtersInput) {
    listPushNotificationCounters(filters: $filters) {
      items {
        PK
        SK
        contentID
        creatorUUID
        creatorHandle
        videoID
        notificationType
        notificationSentDate
        notificationID
        PNOpenedCount
        sentPNTo
        contentCategory1
        contentCategory2
        contentCategory3
        contentLanguage
        notificationSentDateTime
        time
        DateTime
        Day
        contentTitle
        type
        PNSlot
        PNHour
        pnDescription_Te
        pnDescription_Hi
        pnDescription_En
        pnTitle_Te
        pnTitle_Hi
        pnTitle_En
        bigTextTitle_Te
        bigTextTitle_Hi
        bigTextTitle_En
        pnTitle
        pnDescription
      }
      totalPNOpenedCount
      totalSentPNTo
    }
  }
`
export const listVideoPlayCounters = gql`
  query listVideoPlayCounters($feedType: String, $filters: videoPlayCountersInput) {
    listVideoPlayCounters(feedType: $feedType, filters: $filters) {
      items {
        activeUsersEnglish
        activeUsersTelugu
        noOfEnArticlesPublished
        noOfTeArticlesPublished
        PK
        SK
        Day
        Telugu_Video_likes
        Telugu_Video_shares
        Telugu_Video_downloads
        Telugu_Video_views
        Telugu_Video_follows
        Guest_Telugu_Video_likes
        Guest_Telugu_Video_shares
        Guest_Telugu_Video_downloads
        Guest_Telugu_Video_views
        Guest_Telugu_Video_follows
        Hindi_Video_likes
        Hindi_Video_shares
        Hindi_Video_downloads
        Hindi_Video_views
        Hindi_Video_follows
        Guest_Hindi_Video_likes
        Guest_Hindi_Video_shares
        Guest_Hindi_Video_downloads
        Guest_Hindi_Video_views
        Guest_Hindi_Video_follows
        English_Video_likes
        English_Video_shares
        English_Video_downloads
        English_Video_views
        English_Video_follows
        Guest_English_Video_likes
        Guest_English_Video_shares
        Guest_English_Video_downloads
        Guest_English_Video_views
        Guest_English_Video_follows
        OnlyMusic_Video_likes
        OnlyMusic_Video_shares
        OnlyMusic_Video_downloads
        OnlyMusic_Video_views
        OnlyMusic_Video_follows
        Guest_OnlyMusic_Video_likes
        Guest_OnlyMusic_Video_shares
        Guest_OnlyMusic_Video_downloads
        Guest_OnlyMusic_Video_views
        Guest_OnlyMusic_Video_follows
        Hyderabadi_Video_likes
        Hyderabadi_Video_shares
        Hyderabadi_Video_downloads
        Hyderabadi_Video_views
        Hyderabadi_Video_follows
        Guest_Hyderabadi_Video_likes
        Guest_Hyderabadi_Video_shares
        Guest_Hyderabadi_Video_downloads
        Guest_Hyderabadi_Video_views
        Guest_Hyderabadi_Video_follows
        Telugu_Content_Story_likes
        Telugu_Content_Story_shares
        Telugu_Content_Story_views
        Telugu_Content_Story_watchAnalytics
        Guest_Telugu_Content_Story_likes
        Guest_Telugu_Content_Story_shares
        Guest_Telugu_Content_Story_views
        Guest_Telugu_Content_Story_watchAnalytics
        Telugu_Content_CoverStory_likes
        Telugu_Content_CoverStory_shares
        Telugu_Content_CoverStory_views
        Telugu_Content_CoverStory_watchAnalytics
        Guest_Telugu_Content_CoverStory_likes
        Guest_Telugu_Content_CoverStory_shares
        Guest_Telugu_Content_CoverStory_views
        Guest_Telugu_Content_CoverStory_watchAnalytics
        Telugu_Content_Mcq_likes
        Telugu_Content_Mcq_shares
        Telugu_Content_Mcq_views
        Telugu_Content_Mcq_watchAnalytics
        Guest_Telugu_Content_Mcq_likes
        Guest_Telugu_Content_Mcq_shares
        Guest_Telugu_Content_Mcq_views
        Guest_Telugu_Content_Mcq_watchAnalytics
        Telugu_Content_Poll_likes
        Telugu_Content_Poll_shares
        Telugu_Content_Poll_views
        Telugu_Content_Poll_watchAnalytics
        Guest_Telugu_Content_Poll_likes
        Guest_Telugu_Content_Poll_shares
        Guest_Telugu_Content_Poll_views
        Guest_Telugu_Content_Poll_watchAnalytics
        Hindi_Content_Story_likes
        Hindi_Content_Story_shares
        Hindi_Content_Story_views
        Hindi_Content_Story_watchAnalytics
        Guest_Hindi_Content_Story_likes
        Guest_Hindi_Content_Story_shares
        Guest_Hindi_Content_Story_views
        Guest_Hindi_Content_Story_watchAnalytics
        Hindi_Content_CoverStory_likes
        Hindi_Content_CoverStory_shares
        Hindi_Content_CoverStory_views
        Hindi_Content_CoverStory_watchAnalytics
        Guest_Hindi_Content_CoverStory_likes
        Guest_Hindi_Content_CoverStory_shares
        Guest_Hindi_Content_CoverStory_views
        Guest_Hindi_Content_CoverStory_watchAnalytics
        Hindi_Content_Mcq_likes
        Hindi_Content_Mcq_shares
        Hindi_Content_Mcq_views
        Hindi_Content_Mcq_watchAnalytics
        Guest_Hindi_Content_Mcq_likes
        Guest_Hindi_Content_Mcq_shares
        Guest_Hindi_Content_Mcq_views
        Guest_Hindi_Content_Mcq_watchAnalytics
        Hindi_Content_Poll_likes
        Hindi_Content_Poll_shares
        Hindi_Content_Poll_views
        Hindi_Content_Poll_watchAnalytics
        Guest_Hindi_Content_Poll_likes
        Guest_Hindi_Content_Poll_shares
        Guest_Hindi_Content_Poll_views
        Guest_Hindi_Content_Poll_watchAnalytics
        English_Content_Story_likes
        English_Content_Story_shares
        English_Content_Story_views
        English_Content_Story_watchAnalytics
        Guest_English_Content_Story_likes
        Guest_English_Content_Story_shares
        Guest_English_Content_Story_views
        Guest_English_Content_Story_watchAnalytics
        English_Content_CoverStory_likes
        English_Content_CoverStory_shares
        English_Content_CoverStory_views
        English_Content_CoverStory_watchAnalytics
        Guest_English_Content_CoverStory_likes
        Guest_English_Content_CoverStory_shares
        Guest_English_Content_CoverStory_views
        Guest_English_Content_CoverStory_watchAnalytics
        English_Content_Mcq_likes
        English_Content_Mcq_shares
        English_Content_Mcq_views
        English_Content_Mcq_watchAnalytics
        Guest_English_Content_Mcq_likes
        Guest_English_Content_Mcq_shares
        Guest_English_Content_Mcq_views
        Guest_English_Content_Mcq_watchAnalytics
        English_Content_Poll_likes
        English_Content_Poll_shares
        English_Content_Poll_views
        English_Content_Poll_watchAnalytics
        Guest_English_Content_Poll_likes
        Guest_English_Content_Poll_shares
        Guest_English_Content_Poll_views
        Guest_English_Content_Poll_watchAnalytics
        Telugu_Content_Jobs_likes
        Telugu_Content_Jobs_shares
        Telugu_Content_Jobs_views
        Guest_Telugu_Content_Jobs_likes
        Guest_Telugu_Content_Jobs_shares
        Guest_Telugu_Content_Jobs_views
        Telugu_Content_Videos_likes
        Telugu_Content_Videos_shares
        Telugu_Content_Videos_views
        Guest_Telugu_Content_Videos_likes
        Guest_Telugu_Content_Videos_shares
        Guest_Telugu_Content_Videos_views
        English_Content_Jobs_likes
        English_Content_Jobs_shares
        English_Content_Jobs_views
        Guest_English_Content_Jobs_likes
        Guest_English_Content_Jobs_shares
        Guest_English_Content_Jobs_views
        English_Content_Videos_likes
        English_Content_Videos_shares
        English_Content_Videos_views
        Guest_English_Content_Videos_likes
        Guest_English_Content_Videos_shares
        Guest_English_Content_Videos_views
        contentType
        likes
        views
        shares
        downloads
        outlinks
        logins
        State
        District
        Date
        Day
        noOfArticlesPublished

        TopStories
        India
        Telangana
        AP
        World
        Business
        Technology
        Sports
        Lifestyle
        Careers
        Health
        Entertainment_English
        Entertainment_Telugu
        TeluguMovies
        BollyWood
        Travel
        Science
        Politics
        Telugu_Content_SlideShow_likes
        Telugu_Content_SlideShow_shares
        Telugu_Content_SlideShow_views
        Telugu_Content_SlideShow_watchAnalytics
        Guest_Telugu_Content_SlideShow_likes
        Guest_Telugu_Content_SlideShow_shares
        Guest_Telugu_Content_SlideShow_views
        Guest_Telugu_Content_SlideShow_watchAnalytics
        Hindi_Content_SlideShow_likes
        Hindi_Content_SlideShow_shares
        Hindi_Content_SlideShow_views
        Hindi_Content_SlideShow_watchAnalytics
        Guest_Hindi_Content_SlideShow_likes
        Guest_Hindi_Content_SlideShow_shares
        Guest_Hindi_Content_SlideShow_views
        Guest_Hindi_Content_SlideShow_watchAnalytics
        English_Content_SlideShow_likes
        English_Content_SlideShow_shares
        English_Content_SlideShow_views
        English_Content_SlideShow_watchAnalytics
        Guest_English_Content_SlideShow_likes
        Guest_English_Content_SlideShow_shares
        Guest_English_Content_SlideShow_views
        Guest_English_Content_SlideShow_watchAnalytics
        Telugu_Content_liveNews_likes
        Telugu_Content_liveNews_shares
        Telugu_Content_liveNews_views
        Guest_Telugu_Content_liveNews_likes
        Guest_Telugu_Content_liveNews_shares
        Guest_Telugu_Content_liveNews_views
        English_Content_liveNews_likes
        English_Content_liveNews_shares
        English_Content_liveNews_views
        Guest_English_Content_liveNews_likes
        Guest_English_Content_liveNews_shares
        Guest_English_Content_liveNews_views

        Telugu_Content_ShortByte_likes
        Telugu_Content_ShortByte_shares
        Telugu_Content_ShortByte_views
        Guest_Telugu_Content_ShortByte_likes
        Guest_Telugu_Content_ShortByte_shares
        Guest_Telugu_Content_ShortByte_views
        English_Content_ShortByte_likes
        English_Content_ShortByte_shares
        English_Content_ShortByte_views
        Guest_English_Content_ShortByte_likes
        Guest_English_Content_ShortByte_shares
        Guest_English_Content_ShortByte_views

        userType
      }
    }
  }
`

export const getCampaignURL = gql`
  query getCampaignURL($URL: String!, $campaign: String) {
    getCampaignURL(URL: $URL, campaign: $campaign) {
      campaign
      id
      mainURL
      URL
      timestamp
    }
  }
`
export const getBoxOfficeVideos = gql`
  query getBoxOfficeVideos($input: vidAppInput) {
    getBoxOfficeVideos(input: $input) {
      vidApp {
        storyVersion
        flipToStoryVersion
        onlyCoverVersion
        inAppBrowserVersion
        mcqVersion
        pollVersion
        slideShowVersion
        videoVersion
        seriesInfo {
          seriesID
          seriesName
        }
        PNOpenedByFollowersCount
        PNSentToFollowersCount
        youtubeLink
        instagramLink
        chosenSocialProfileForPromotion
        isDuet
        duetVideoID
        duetVideoDownloadUrl
        duetCount
        creatorProfilePicKey
        PK
        downloadVideoMode
        SK
        videoID
        videoStatus
        videoDescription
        creatorVideoHashTag1
        creatorVideoHashTag2
        creatorVideoHashTag3
        creatorVideoHashTag4
        videoLanguage
        tenPercentDuration
        thirtyPercentDuration
        twentyPercentDuration
        fourtyPercentDuration
        fiftyPercentDuration
        sixtyPercentDuration
        seventyPercentDuration
        eigtyPercentDuration
        ninetyPercentDuration
        hundredPercentDuration
        viewed
        likes
        primaryCategory
        points
        creatorUUID
        creatorHandle
        creatorName
        creatorProfilePicURL
        GSIByCreatorIDSK
        moderatorVideoLanguage
        allowComments
        allowDownloads
        sharedVideoCount
        commentsCount
        audioTrackInfo
        reportedAsInappropriateCount
        downloadCount
        VideoblockedDateTime
        videoMetaInfo {
          previewURL
          dynamicURL
          totalDuration
          downloadURL
          uid
          thumbnail
          thumbnailTimestampPct
          readyToStream
          status {
            state
            pctComplete
          }
          meta {
            name
            type
          }
          created
          modified
          size
          preview
          allowedOrigins
          requireSignedURLs
          uploaded
          uploadExpiry
          maxSizeBytes
          maxDurationSeconds
          duration
          input {
            width
            height
          }
          playback {
            hls
            dash
          }
          watermark
        }
        type
        contentID
        contentType
        contentLanguage
        contentLanguages
        contentMainCategory
        contentVersion
        contentCategory1
        contentCategory2
        contentCategory3
        createdAs
        contentPlanner
        scheduledDate
        scheduledTime
        archivalDate
        contentMetaInfo {
          thumbnailURL
          contentImage
          slideShowDetails {
            slideShowTitle
            slideShowTitle_Te
            slideShowTitle_En
            slideShowTitle_Hi

            slideShowImage
            pages {
              pageType
              storyDetails {
                readMoreLink
                showRating
                reviewRating
                storyTitle
                storyTitle_Te
                storyTitle_En
                storyTitle_Hi
                storyYoutubeImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardDescription
                storyCardDescription_Te
                storyCardDescription_En
                storyCardDescription_Hi
                coverStoryVideoURL
                youtubeID
                youtubeVideoOrientation
                imageTemplate
                imageTemplateDescription
                imageTemplateKey
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
              coverStoryDetails {
                flipToStoryDetails {
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  contentNewLinkDetails {
                    linkSubText
                    linkAvatar
                    category
                    urlType
                    linkText
                    buttonPositionFromTop
                    buttonPositionFromLeft
                    markdownLabel
                    pageLink
                    pageInfo {
                      PK
                      SK
                      pageValue
                      pageTitle
                      pageThumbnail
                      pageDescription
                      pageTargetArea
                      pageCreatedDateTime
                      pageModifiedDateTime
                      pageLanguage
                      pageSubscriptionStatus
                      pageTemplate
                    }
                    peopleLink
                    peopleInfo {
                      PK
                      SK
                      peopleType
                      peopleName
                      peopleValue
                      peopleCreatedDateTime
                      peopleModifiedDateTime
                      peopleCoverImage
                      peopleProfileImage
                    }
                    listLink
                    listInfo {
                      PK
                      SK
                      listValue
                      listName
                      listName_Te
                      listName_Hi
                      listName_En
                      listThumbnail
                      listStatus
                      listType
                    }
                    collectionLink
                    collectionInfo {
                      PK
                      SK
                      collectionType
                      collectionName
                      collectionValue
                      collectionImage
                      collectionCreatedDateTime
                      collectionModifiedDateTime
                    }
                    videoLink
                    contentLink
                    playstoreLink
                    appstoreLink
                    saavnLink
                    gaanaLink
                    httpsLink
                    buttonStyle
                    buttonPosition
                    tweetType
                    facebookLink
                    trackerLink
                    watchType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  coverStoryCardImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                }
                onlyCoverDetails {
                  advancedOverlayStyles {
                    advancedOverlayStyleType
                    enableSeperator
                    overlayDescriptionBold
                    overlayDescriptionColor
                    overlayDescriptionFontSize
                    overlayPositionFromBottom
                    overlayTitleBold
                    overlayTitleColor
                    overlayTitleFontSize
                    overlayBgColor
                    seperatorColor
                  }
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  contentNewLinkDetails {
                    linkSubText
                    linkAvatar
                    category
                    urlType
                    linkText
                    buttonPositionFromTop
                    buttonPositionFromLeft
                    markdownLabel
                    pageLink
                    pageInfo {
                      PK
                      SK
                      pageValue
                      pageTitle
                      pageThumbnail
                      pageDescription
                      pageTargetArea
                      pageCreatedDateTime
                      pageModifiedDateTime
                      pageLanguage
                      pageSubscriptionStatus
                      pageTemplate
                    }
                    peopleLink
                    peopleInfo {
                      PK
                      SK
                      peopleType
                      peopleName
                      peopleValue
                      peopleCreatedDateTime
                      peopleModifiedDateTime
                      peopleCoverImage
                      peopleProfileImage
                    }
                    listLink
                    listInfo {
                      PK
                      SK
                      listValue
                      listName
                      listName_Te
                      listName_Hi
                      listName_En
                      listThumbnail
                      listStatus
                      listType
                    }
                    collectionLink
                    collectionInfo {
                      PK
                      SK
                      collectionType
                      collectionName
                      collectionValue
                      collectionImage
                      collectionCreatedDateTime
                      collectionModifiedDateTime
                    }
                    videoLink
                    contentLink
                    playstoreLink
                    appstoreLink
                    saavnLink
                    gaanaLink
                    httpsLink
                    buttonStyle
                    buttonPosition
                    tweetType
                    facebookLink
                    trackerLink
                    watchType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                }
                inAppBrowserDetails {
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  contentNewLinkDetails {
                    linkSubText
                    linkAvatar
                    category
                    urlType
                    linkText
                    buttonPositionFromTop
                    buttonPositionFromLeft
                    markdownLabel
                    pageLink
                    pageInfo {
                      PK
                      SK
                      pageValue
                      pageTitle
                      pageThumbnail
                      pageDescription
                      pageTargetArea
                      pageCreatedDateTime
                      pageModifiedDateTime
                      pageLanguage
                      pageSubscriptionStatus
                      pageTemplate
                    }
                    peopleLink
                    peopleInfo {
                      PK
                      SK
                      peopleType
                      peopleName
                      peopleValue
                      peopleCreatedDateTime
                      peopleModifiedDateTime
                      peopleCoverImage
                      peopleProfileImage
                    }
                    listLink
                    listInfo {
                      PK
                      SK
                      listValue
                      listName
                      listName_Te
                      listName_Hi
                      listName_En
                      listThumbnail
                      listStatus
                      listType
                    }
                    collectionLink
                    collectionInfo {
                      PK
                      SK
                      collectionType
                      collectionName
                      collectionValue
                      collectionImage
                      collectionCreatedDateTime
                      collectionModifiedDateTime
                    }
                    videoLink
                    contentLink
                    playstoreLink
                    appstoreLink
                    saavnLink
                    gaanaLink
                    httpsLink
                    buttonStyle
                    buttonPosition
                    tweetType
                    facebookLink
                    trackerLink
                    watchType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  link
                  linkText
                  textColor
                  backGroundTitle
                  contentTitlePosition
                }
                coverStoryType
              }
              mcqDetails {
                mcqTitle
                mcqTitle_Te
                mcqTitle_En
                mcqTitle_Hi
                explanationCardTitle
                explanationCardTitle_Te
                explanationCardTitle_En
                explanationCardTitle_Hi
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }

                mcqImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                mcqCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                answerExplanation
                answerExplanation_Te
                answerExplanation_En
                answerExplanation_Hi
                answersInfo {
                  id
                  answer
                  answer_Te
                  answer_En
                  answer_Hi
                  image
                  correct
                  ordering
                  weight
                  placeholder
                }
                textColor
              }
              pollDetails {
                pollBgColor
                pollImage {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                pollInfo {
                  pollOptionID
                  choice_Te
                  choice_Hi
                  choice_En
                  votes
                }
                pollPositionFromTop
                selectedPollColor
                textColor
                pollTitle
                pollTitle_Te
                pollTitle_En
                pollTitle_Hi
                pollDescription
                pollDescription_Te
                pollDescription_En
                pollDescription_Hi
                pollOptions
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
            }
          }

          storyDetails {
            readMoreLink
            showRating
            reviewRating
            storyTitle
            storyTitle_Te
            storyTitle_En
            storyTitle_Hi
            storyYoutubeImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            storyCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            storyCardDescription
            storyCardDescription_Te
            storyCardDescription_En
            storyCardDescription_Hi
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          coverStoryDetails {
            flipToStoryDetails {
              styleType

              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              coverStoryCardImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
            }
            onlyCoverDetails {
              advancedOverlayStyles {
                advancedOverlayStyleType
                enableSeperator
                overlayDescriptionBold
                overlayDescriptionColor
                overlayDescriptionFontSize
                overlayPositionFromBottom
                overlayTitleBold
                overlayTitleColor
                overlayTitleFontSize
                overlayBgColor
                seperatorColor
              }
              styleType
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
            }
            inAppBrowserDetails {
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              link
              linkText
              textColor
              backGroundTitle
              contentTitlePosition
            }
            coverStoryType
          }
          mcqDetails {
            mcqTitle
            mcqTitle_Te
            mcqTitle_En
            mcqTitle_Hi
            explanationCardTitle
            explanationCardTitle_Te
            explanationCardTitle_En
            explanationCardTitle_Hi
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            mcqImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            mcqCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            answerExplanation
            answerExplanation_Te
            answerExplanation_En
            answerExplanation_Hi
            answersInfo {
              id
              answer
              answer_Te
              answer_En
              answer_Hi
              image
              correct
              ordering
              weight
              placeholder
            }
            textColor
          }
          pollDetails {
            pollBgColor
            pollImage {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            pollInfo {
              pollOptionID
              choice_Te
              choice_Hi
              choice_En
              votes
            }
            pollPositionFromTop
            selectedPollColor
            textColor
            pollTitle
            pollTitle_Te
            pollTitle_En
            pollTitle_Hi
            pollDescription
            pollDescription_Te
            pollDescription_En
            pollDescription_Hi
            pollOptions
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
          }
          content
          questionHint
          contentImage
          questionType
          link
          linkText
          published
          explanation
          explanationImages

          userExplanation
          wrongAnswerText
          rightAnswerText
          createdDate
          answersInfo {
            correct
            ordering
            placeholder
            weight
            answer
            answer_Te
            answer_En
            answer_Hi
            image
          }
        }
      }

      UserFollowings
      UserLiking
      VerifiedUsers
    }
  }
`
export const listDistricts = gql`
  query listDistricts {
    listDistricts {
      items {
        stateCodec
        district
      }
    }
  }
`

export const listContentsByRedisTime = gql`
  query($limit: Int, $nextToken: String, $paginationCount: Int, $language: String) {
    listContentsByRedisTime(
      limit: $limit
      nextToken: $nextToken
      paginationCount: $paginationCount
      language: $language
    ) {
      items {
        originalCreatorName
        originalCreatorHandle
        storyType
        isInAppMessage
        inAppMessageDetails {
          conditionType
          creatorVideosCount
          gender
          ageGroup
          creatorFollowersCount
          trackObjective
          when
          noOfTimes
          showFor
          priority
          conditionalOperator
          socialPlatForm
          socialPlatFormSub
          targetImpressions
          targetClicks
          campaignType
          inHousePosition
          classifiedPostPosition
          campaignStartDateTime
          campaignEndDateTime
          campaignPosition
          campaignTargetImpressions
          campaignTargetImpressionsPerUser
        }
        stickyPost
        showSticky
        positionFromTop
        stickyEndDateTime
        stickyTargetImpressions
        stickyInProgressDateTime
        pushRankUpTo
        pushRankTo
        isPushRankActive
        tempPositionFromTop
        archivedFromRedis
        pnPriority
        createdFrom
        approvedContentLanguages
        notificationSentDateTime
        isScheduled
        contentID
        contentCreatedDateTime
        contentModifiedDateTime
        contentPublishedDateTime
        PK
        SK
        type
        contentType
        contentVersion
        linkOpenedCount
        creatorVideoHashTag1
        creatorVideoHashTag2
        creatorVideoHashTag3
        creatorVideoHashTag4
        creatorVideoHashTag1AndType
        creatorVideoHashTag2AndType
        creatorVideoHashTag3AndType
        creatorVideoHashTag4AndType
        genderSpecific
        tagsWithGenderTarget
        contentLanguage
        contentLanguages
        approvedContentLanguages
        targetAreas
        targetAreaV2
        createInBoxOffice
        allowShare
        allowComments
        creatorUUID
        creatorName
        creatorHandle
        creatorJobRole
        creatorProfilePicURL
        creatorHandleWatermarkPath
        viewed
        likes
        points
        commentsCount
        sharedVideoCount
        contentMainCategory
        contentVersion
        contentCategory1
        contentCategory2
        contentCategory3
        createdAs
        contentPlanner
        scheduledDate
        scheduledDate_En
        scheduledDate_Te
        scheduledDate_Hi
        scheduledTime
        scheduledTime_En
        scheduledTime_Hi
        scheduledTime_Te
        archivalDate
        selectedAutoExpireDate
        selectedAutoDeleteDate
        sendPushNotification
        sendPNWithImage
        bigTextTitle
        bigTextTitle_Te
        bigTextTitle_En
        bigTextTitle_Hi
        pnTitle
        pnTitle_Te
        pnTitle_En
        pnTitle_Hi
        pnDescription
        pnDescription_Te
        pnDescription_En
        pnDescription_Hi
        peopleValues {
          peopleType
          peopleName
          peopleValue
          peopleCoverImage
        }
        isLiveNewsContent
        contentMetaInfo {
          liveCricketDetails {
            liveCricketInfo
            liveCricketTitle_Te
            liveCricketTitle_Hi
            liveCricketTitle_En
            liveCricketDescription_Te
            liveCricketDescription_Hi
            liveCricketDescription_En
            liveCricketInfo
            liveCricketImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
          }
          cricketPointsTableDetails {
            cricketPointsTableDescription_En
            cricketPointsTableDescription_Hi
            cricketPointsTableDescription_Te
            cricketPointsTableTitle_En
            cricketPointsTableTitle_Hi
            cricketPointsTableTitle_Te
            cricketPointsTableImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
          }
          thumbnailURL
          contentImage
          slideShowDetails {
            autoSlideOn
            autoSlideSeconds

            slideShowTitle
            slideShowTitle_Te
            slideShowTitle_En
            slideShowTitle_Hi
            slideShowImage
            pages {
              pageType
              storyDetails {
                shortByteTemplateType
                readMoreLink
                showRating
                reviewRating
                storyTitle
                storyTitle_Te
                storyTitle_En
                storyTitle_Hi
                storyYoutubeImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardDescription
                storyCardDescription_Te
                storyCardDescription_En
                storyCardDescription_Hi
                coverStoryVideoURL
                youtubeID
                youtubeVideoOrientation
                imageTemplate
                imageTemplateDescription
                imageTemplateKey
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
              coverStoryDetails {
                flipToStoryDetails {
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  coverStoryCardImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                }
                onlyCoverDetails {
                  advancedOverlayStyles {
                    advancedOverlayStyleType
                    enableSeperator
                    overlayDescriptionBold
                    overlayDescriptionColor
                    overlayDescriptionFontSize
                    overlayPositionFromBottom
                    overlayTitleBold
                    overlayTitleColor
                    overlayTitleFontSize
                    overlayBgColor
                    seperatorColor
                  }
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                }
                inAppBrowserDetails {
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  link
                  linkText
                  textColor
                  backGroundTitle
                  contentTitlePosition
                }
                coverStoryType
              }
              mcqDetails {
                mcqTitle
                mcqTitle_Te
                mcqTitle_En
                mcqTitle_Hi
                explanationCardTitle
                explanationCardTitle_Te
                explanationCardTitle_En
                explanationCardTitle_Hi
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }

                mcqImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                mcqCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                answerExplanation
                answerExplanation_Te
                answerExplanation_En
                answerExplanation_Hi
                answersInfo {
                  id
                  answer
                  answer_Te
                  answer_En
                  answer_Hi
                  image
                  correct
                  ordering
                  weight
                  placeholder
                }
                textColor
              }
              pollDetails {
                pollBgColor
                pollImage {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                pollInfo {
                  pollOptionID
                  choice_Te
                  choice_Hi
                  choice_En
                  votes
                }
                pollPositionFromTop
                selectedPollColor
                textColor
                pollTitle
                pollTitle_Te
                pollTitle_En
                pollTitle_Hi
                pollDescription
                pollDescription_Te
                pollDescription_En
                pollDescription_Hi
                pollOptions
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
            }
          }

          storyDetails {
            shortByteTemplateType
            readMoreLink
            showRating
            reviewRating
            storyTitle
            storyTitle_Te
            storyTitle_En
            storyTitle_Hi
            storyYoutubeImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            storyCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            storyCardDescription
            storyCardDescription_Te
            storyCardDescription_En
            storyCardDescription_Hi
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          coverStoryDetails {
            flipToStoryDetails {
              styleType
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              coverStoryCardImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
            }
            onlyCoverDetails {
              advancedOverlayStyles {
                advancedOverlayStyleType
                enableSeperator
                overlayDescriptionBold
                overlayDescriptionColor
                overlayDescriptionFontSize
                overlayPositionFromBottom
                overlayTitleBold
                overlayTitleColor
                overlayTitleFontSize
                overlayBgColor
                seperatorColor
              }
              styleType
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
            }
            inAppBrowserDetails {
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              link
              linkText
              textColor
              backGroundTitle
              contentTitlePosition
            }
            coverStoryType
          }
          mcqDetails {
            mcqTitle
            mcqTitle_Te
            mcqTitle_En
            mcqTitle_Hi
            explanationCardTitle
            explanationCardTitle_Te
            explanationCardTitle_En
            explanationCardTitle_Hi
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            mcqImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            mcqCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            answerExplanation
            answerExplanation_Te
            answerExplanation_En
            answerExplanation_Hi
            answersInfo {
              id
              answer
              answer_Te
              answer_En
              answer_Hi
              image
              correct
              ordering
              weight
              placeholder
            }
            textColor
          }
          pollDetails {
            pollBgColor
            pollImage {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            pollInfo {
              pollOptionID
              choice_Te
              choice_Hi
              choice_En
              votes
            }
            pollPositionFromTop
            selectedPollColor
            textColor
            pollTitle
            pollTitle_Te
            pollTitle_En
            pollTitle_Hi
            pollDescription
            pollDescription_Te
            pollDescription_En
            pollDescription_Hi
            pollOptions
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
          }
          liveNewsSectionDetails {
            readMoreLink
            showRating
            reviewRating
            liveNewsTitle
            liveNewsTitle_Te
            liveNewsTitle_En
            liveNewsTitle_Hi
            createdAs
            createdFrom
            createdDateTime
            modifiedBy
            modifiedDateTime
            liveNewsYoutubeImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            liveNewsImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            liveNewsVideoURL
            liveNewsYoutubeID
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            liveNewsDescription
            liveNewsDescription_Te
            liveNewsDescription_En
            liveNewsDescription_Hi
            liveNewsVideoURL
            liveNewsYoutubeID
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          content
          questionHint
          contentImage
          questionType
          link
          linkText
          published
          explanation
          explanationImages

          userExplanation
          wrongAnswerText
          rightAnswerText
          createdDate
          answersInfo {
            correct
            ordering
            placeholder
            weight
            answer
            answer_Te
            answer_En
            answer_Hi
            image
          }
        }
      }
      nextToken
    }
  }
`
export const searchContents = gql`
  query(
    $currentLoggedInUserID: String
    $search: String
    $facetValue: String
    $facet: String
    $from: Int
    $limit: Int
    $appInfoFrontEnd: appInfoFrontEndInput
  ) {
    searchContents(
      currentLoggedInUserID: $currentLoggedInUserID
      search: $search
      facetValue: $facetValue
      facet: $facet
      from: $from
      limit: $limit
      appInfoFrontEnd: $appInfoFrontEnd
    ) {
      total
      filteredContentTypes {
        key
        doc_count
      }
      filteredContentMainCategories {
        key
        doc_count
      }
      filteredSecondLevelContentCategories {
        key
        doc_count
      }
      filteredThirdLevelContentCategories {
        key
        doc_count
      }
      filteredFirstLevelContentCategories {
        key
        doc_count
      }

      items {
        stickyPost
        showSticky
        positionFromTop
        stickyEndDateTime
        stickyTargetImpressions
        stickyInProgressDateTime
        pushRankUpTo
        pushRankTo
        isPushRankActive
        tempPositionFromTop
        archivedFromRedis
        pnPriority
        createdFrom
        approvedContentLanguages
        notificationSentDateTime
        isScheduled
        contentID
        contentCreatedDateTime
        contentModifiedDateTime
        contentPublishedDateTime
        PK
        SK
        type
        contentType
        contentVersion
        linkOpenedCount
        creatorVideoHashTag1
        creatorVideoHashTag2
        creatorVideoHashTag3
        creatorVideoHashTag4
        creatorVideoHashTag1AndType
        creatorVideoHashTag2AndType
        creatorVideoHashTag3AndType
        creatorVideoHashTag4AndType
        genderSpecific
        tagsWithGenderTarget
        contentLanguage
        contentLanguages
        approvedContentLanguages
        targetAreas
        targetAreaV2
        createInBoxOffice
        allowShare
        allowComments
        creatorUUID
        creatorName
        creatorHandle
        creatorJobRole
        creatorProfilePicURL
        creatorHandleWatermarkPath
        viewed
        likes
        points
        commentsCount
        sharedVideoCount
        contentMainCategory
        contentVersion
        contentCategory1
        contentCategory2
        contentCategory3
        createdAs
        contentPlanner
        scheduledDate
        scheduledDate_En
        scheduledDate_Te
        scheduledDate_Hi
        scheduledTime
        scheduledTime_En
        scheduledTime_Hi
        scheduledTime_Te
        archivalDate
        selectedAutoExpireDate
        selectedAutoDeleteDate
        sendPushNotification
        sendPNWithImage
        bigTextTitle
        bigTextTitle_Te
        bigTextTitle_En
        bigTextTitle_Hi
        pnTitle
        pnTitle_Te
        pnTitle_En
        pnTitle_Hi
        pnDescription
        pnDescription_Te
        pnDescription_En
        pnDescription_Hi
        peopleValues {
          peopleType
          peopleName
          peopleValue
          peopleCoverImage
        }
        isLiveNewsContent
        contentMetaInfo {
          thumbnailURL
          contentImage
          slideShowDetails {
            autoSlideOn
            autoSlideSeconds

            slideShowTitle
            slideShowTitle_Te
            slideShowTitle_En
            slideShowTitle_Hi
            slideShowImage
            pages {
              pageType
              storyDetails {
                shortByteTemplateType
                readMoreLink
                showRating
                reviewRating
                storyTitle
                storyTitle_Te
                storyTitle_En
                storyTitle_Hi
                storyYoutubeImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardDescription
                storyCardDescription_Te
                storyCardDescription_En
                storyCardDescription_Hi
                coverStoryVideoURL
                youtubeID
                youtubeVideoOrientation

                imageTemplate
                imageTemplateDescription
                imageTemplateKey
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
              coverStoryDetails {
                flipToStoryDetails {
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  coverStoryCardImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                }
                onlyCoverDetails {
                  advancedOverlayStyles {
                    advancedOverlayStyleType
                    enableSeperator
                    overlayDescriptionBold
                    overlayDescriptionColor
                    overlayDescriptionFontSize
                    overlayPositionFromBottom
                    overlayTitleBold
                    overlayTitleColor
                    overlayTitleFontSize
                    overlayBgColor
                    seperatorColor
                  }
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                }
                inAppBrowserDetails {
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  link
                  linkText
                  textColor
                  backGroundTitle
                  contentTitlePosition
                }
                coverStoryType
              }
              mcqDetails {
                mcqTitle
                mcqTitle_Te
                mcqTitle_En
                mcqTitle_Hi
                explanationCardTitle
                explanationCardTitle_Te
                explanationCardTitle_En
                explanationCardTitle_Hi
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }

                mcqImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                mcqCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                answerExplanation
                answerExplanation_Te
                answerExplanation_En
                answerExplanation_Hi
                answersInfo {
                  id
                  answer
                  answer_Te
                  answer_En
                  answer_Hi
                  image
                  correct
                  ordering
                  weight
                  placeholder
                }
                textColor
              }
              pollDetails {
                pollBgColor
                pollImage {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                pollInfo {
                  pollOptionID
                  choice_Te
                  choice_Hi
                  choice_En
                  votes
                }
                pollPositionFromTop
                selectedPollColor
                textColor
                pollTitle
                pollTitle_Te
                pollTitle_En
                pollTitle_Hi
                pollDescription
                pollDescription_Te
                pollDescription_En
                pollDescription_Hi
                pollOptions
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
            }
          }

          storyDetails {
            shortByteTemplateType
            readMoreLink
            showRating
            reviewRating
            storyTitle
            storyTitle_Te
            storyTitle_En
            storyTitle_Hi
            storyYoutubeImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            storyCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            storyCardDescription
            storyCardDescription_Te
            storyCardDescription_En
            storyCardDescription_Hi
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          coverStoryDetails {
            flipToStoryDetails {
              styleType
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              coverStoryCardImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
            }
            onlyCoverDetails {
              advancedOverlayStyles {
                advancedOverlayStyleType
                enableSeperator
                overlayDescriptionBold
                overlayDescriptionColor
                overlayDescriptionFontSize
                overlayPositionFromBottom
                overlayTitleBold
                overlayTitleColor
                overlayTitleFontSize
                overlayBgColor
                seperatorColor
              }
              styleType
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
            }
            inAppBrowserDetails {
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              link
              linkText
              textColor
              backGroundTitle
              contentTitlePosition
            }
            coverStoryType
          }
          mcqDetails {
            mcqTitle
            mcqTitle_Te
            mcqTitle_En
            mcqTitle_Hi
            explanationCardTitle
            explanationCardTitle_Te
            explanationCardTitle_En
            explanationCardTitle_Hi
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            mcqImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            mcqCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            answerExplanation
            answerExplanation_Te
            answerExplanation_En
            answerExplanation_Hi
            answersInfo {
              id
              answer
              answer_Te
              answer_En
              answer_Hi
              image
              correct
              ordering
              weight
              placeholder
            }
            textColor
          }
          pollDetails {
            pollBgColor
            pollImage {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            pollInfo {
              pollOptionID
              choice_Te
              choice_Hi
              choice_En
              votes
            }
            pollPositionFromTop
            selectedPollColor
            textColor
            pollTitle
            pollTitle_Te
            pollTitle_En
            pollTitle_Hi
            pollDescription
            pollDescription_Te
            pollDescription_En
            pollDescription_Hi
            pollOptions
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
          }
          liveNewsSectionDetails {
            readMoreLink
            showRating
            reviewRating
            liveNewsTitle
            liveNewsTitle_Te
            liveNewsTitle_En
            liveNewsTitle_Hi
            createdAs
            createdFrom
            createdDateTime
            modifiedBy
            modifiedDateTime
            liveNewsYoutubeImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            liveNewsImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            liveNewsVideoURL
            liveNewsYoutubeID
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            liveNewsDescription
            liveNewsDescription_Te
            liveNewsDescription_En
            liveNewsDescription_Hi
            liveNewsVideoURL
            liveNewsYoutubeID
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          content
          questionHint
          contentImage
          questionType
          link
          linkText
          published
          explanation
          explanationImages

          userExplanation
          wrongAnswerText
          rightAnswerText
          createdDate
          answersInfo {
            correct
            ordering
            placeholder
            weight
            answer
            answer_Te
            answer_En
            answer_Hi
            image
          }
        }
      }
    }
  }
`

export const getConfiguredDetails = gql`
  query getConfiguredDetails($PK: String) {
    getConfiguredDetails(PK: $PK) {
      items {
        PK
        listCreatedDateTime
        listModifiedDateTime
        listThumbnail
        listValue
        listName
        listName_En
        listName_Hi
        listName_Te
        listDescription
        listDescription_En
        listDescription_Hi
        listDescription_Te
        pageValue
        pageTitle
        pageSubscriptionStatus
        pageTemplate
        pageCreatedDateTime
        pageModifiedDateTime
        pageThumbnail
        pageDescription
        pageTargetArea
        collectionCreatedDateTime
        collectionModifiedDateTime
        collectionImage
        collectionValue
        collectionName
        collectionDescription
        collectionType
        targetArea
      }
    }
  }
`
export const listCreatorAnalytics = gql`
  query listCreatorAnalytics($date: String) {
    listCreatorAnalytics(date: $date) {
      items {
        PK
        SK
        creatorUUID
        creatorName
        creatorHandle
        userProfilePicURL
        createdDateTime
        noOf_Hindi_ContentsCreated
        noOf_Telugu_ContentsCreated
        noOf_English_ContentsCreated
        noOfContentsCreated
        noOfContentsPublished
        noOf_Telugu_ContentsPublished
        noOf_English_ContentsPublished
        noOf_Hindi_ContentsPublished
      }
      nextToken
    }
  }
`
export const listNewsArticles = gql`
  query listNewsArticles(
    $filterBy: String
    $category: String
    $siteName: String
    $searchBy: String
    $limit: Int
    $fromTime: Int
    $toTime: Int
    $nextToken: String
  ) {
    listNewsArticles(
      filterBy: $filterBy
      category: $category
      siteName: $siteName
      searchBy: $searchBy
      limit: $limit
      fromTime: $fromTime
      toTime: $toTime
      nextToken: $nextToken
    ) {
      items {
        PK
        SK
        newsarticleID
        newsarticleURL
        newsarticleImage
        newsarticleStatus
        newsarticlePosition
        newsarticleStatusUpdatedBy
        newsarticleCreatedDateTime
        newsarticleSortTime
        title
        shortTitle
        category
        siteName
      }
      nextToken
    }
  }
`
export const getUserRolesAndPermissions = gql`
  query getUserRolesAndPermissions($mobileNumber: String) {
    getUserRolesAndPermissions(mobileNumber: $mobileNumber) {
      PK
      userRolesAndPermissions {
        roleName
        permissions {
          name
          selected
        }
      }
    }
  }
`
export const listConfiguredSitesAndCategories = gql`
  query listConfiguredSitesAndCategories {
    listConfiguredSitesAndCategories {
      configuredSites
      configuredCategories
    }
  }
`
export const searchContentsByTypeAndCategory = gql`
  query searchContentsByTypeAndCategory(
    $type: String
    $contentType: String
    $storyType: String
    $limit: Int
    $nextToken: String
  ) {
    searchContentsByTypeAndCategory(
      type: $type
      contentType: $contentType
      storyType: $storyType
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        syncToYousaytv
        addedTargetAreaCategories
        addedNewsCategories
        targetAreaCategoriesArr
        newsCategoriesArr
        wordPressInfo {
          wordPressCategoryIDs
          wordPressGalleryIDs
          isContentEditedInWordPress
          wordPressMediaID
          wordPressID
          wordPressContentCategory1ID
          wordPressContentCategory2ID
          wordPressContentCategory3ID
          wordPressTagIDs
          wordPressPostURL
          wordPressPermaLink
          wordPressPostStatus
        }
        polledCount
        isInAppMessage
        inAppMessageDetails {
          type
          description
          message
          yousayCreatorID
          imageURL
          videoID
          buttons
          repeat
          conditionType
          creatorVideosCount
          gender
          ageGroup
          creatorFollowersCount
          buttonText
          buttonIcon
          buttonBelowDescription
          buttonDestinationURL
          minimumDuration
          canCloseBeforeDurarion
          trackObjective
          when
          noOfTimes
          showFor
          priority
          conditionalOperator
          socialPlatForm
          socialPlatFormSub
          targetImpressions
          targetClicks
          campaignStartDateTime
          campaignEndDateTime
          campaignType
          inHousePosition
          classifiedPostPosition
          campaignPosition
          campaignTargetImpressions
          campaignTargetImpressionsPerUser
        }
        polledCount
        stickyPost
        stickyEndDateTime
        positionFromTop
        showSticky
        stickyTargetImpressions
        stickyInProgressDateTime
        pushRankUpTo
        pushRankTo
        isPushRankActive
        tempPositionFromTop
        archivedFromRedis
        pnPriority
        createdFrom
        approvedContentLanguages
        notificationSentDateTime
        isScheduled
        contentID
        contentCreatedDateTime
        contentModifiedDateTime
        contentPublishedDateTime
        PK
        SK
        type
        contentType
        contentVersion
        linkOpenedCount
        creatorVideoHashTag1
        creatorVideoHashTag2
        creatorVideoHashTag3
        creatorVideoHashTag4
        creatorVideoHashTag1AndType
        creatorVideoHashTag2AndType
        creatorVideoHashTag3AndType
        creatorVideoHashTag4AndType
        genderSpecific
        tagsWithGenderTarget
        contentLanguage
        contentLanguages
        approvedContentLanguages
        targetAreas
        targetAreaV2
        createInBoxOffice
        allowShare
        allowComments
        creatorUUID
        creatorName
        creatorHandle
        creatorJobRole
        creatorProfilePicURL
        creatorHandleWatermarkPath
        viewed
        likes
        points
        commentsCount
        sharedVideoCount
        contentMainCategory
        contentVersion
        contentCategory1
        contentCategory2
        contentCategory3
        createdAs
        contentPlanner
        scheduledDate
        scheduledDate_En
        scheduledDate_Te
        scheduledDate_Hi
        scheduledTime
        scheduledTime_En
        scheduledTime_Hi
        scheduledTime_Te
        archivalDate
        selectedAutoExpireDate
        selectedAutoDeleteDate
        sendPushNotification
        sendPNWithImage
        bigTextTitle
        bigTextTitle_Te
        bigTextTitle_En
        bigTextTitle_Hi
        pnTitle
        pnTitle_Te
        pnTitle_En
        pnTitle_Hi
        pnDescription
        pnDescription_Te
        pnDescription_En
        pnDescription_Hi
        peopleValues {
          peopleType
          peopleName
          peopleValue
          peopleCoverImage
        }
        matchKey
        storyType
        associationKey
        tournamentKey
        isLiveNewsContent
        contentMetaInfo {
          liveCricketDetails {
            liveCricketInfo
            liveCricketTitle_Te
            liveCricketTitle_Hi
            liveCricketTitle_En
            liveCricketDescription_Te
            liveCricketDescription_Hi
            liveCricketDescription_En
            liveCricketInfo
            liveCricketImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
          }
          cricketPointsTableDetails {
            cricketPointsTableDescription_En
            cricketPointsTableDescription_Hi
            cricketPointsTableDescription_Te
            cricketPointsTableTitle_En
            cricketPointsTableTitle_Hi
            cricketPointsTableTitle_Te
            cricketPointsTableImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
          }
          thumbnailURL
          contentImage
          slideShowDetails {
            autoSlideOn
            autoSlideSeconds

            slideShowTitle
            slideShowTitle_Te
            slideShowTitle_En
            slideShowTitle_Hi
            slideShowImage
            pages {
              pageType
              storyDetails {
                shortByteTemplateType
                readMoreLink
                showRating
                reviewRating
                storyTitle
                storyTitle_Te
                storyTitle_En
                storyTitle_Hi
                storyYoutubeImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                storyCardDescription
                storyCardDescription_Te
                storyCardDescription_En
                storyCardDescription_Hi
                coverStoryVideoURL
                youtubeID
                youtubeVideoOrientation
                imageTemplate
                imageTemplateDescription
                imageTemplateKey
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
              coverStoryDetails {
                flipToStoryDetails {
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  contentNewLinkDetails {
                    linkSubText
                    linkAvatar
                    category
                    urlType
                    linkText
                    buttonPositionFromTop
                    buttonPositionFromLeft
                    markdownLabel
                    pageLink
                    pageInfo {
                      PK
                      SK
                      pageValue
                      pageTitle
                      pageThumbnail
                      pageDescription
                      pageTargetArea
                      pageCreatedDateTime
                      pageModifiedDateTime
                      pageLanguage
                      pageSubscriptionStatus
                      pageTemplate
                    }
                    peopleLink
                    peopleInfo {
                      PK
                      SK
                      peopleType
                      peopleName
                      peopleValue
                      peopleCreatedDateTime
                      peopleModifiedDateTime
                      peopleCoverImage
                      peopleProfileImage
                    }
                    listLink
                    listInfo {
                      PK
                      SK
                      listValue
                      listName
                      listName_Te
                      listName_Hi
                      listName_En
                      listThumbnail
                      listStatus
                      listType
                    }
                    collectionLink
                    collectionInfo {
                      PK
                      SK
                      collectionType
                      collectionName
                      collectionValue
                      collectionImage
                      collectionCreatedDateTime
                      collectionModifiedDateTime
                    }
                    videoLink
                    contentLink
                    playstoreLink
                    appstoreLink
                    saavnLink
                    gaanaLink
                    httpsLink
                    buttonStyle
                    buttonPosition
                    tweetType
                    facebookLink
                    trackerLink
                    watchType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  coverStoryCardImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                }
                onlyCoverDetails {
                  advancedOverlayStyles {
                    advancedOverlayStyleType
                    enableSeperator
                    overlayDescriptionBold
                    overlayDescriptionColor
                    overlayDescriptionFontSize
                    overlayPositionFromBottom
                    overlayTitleBold
                    overlayTitleColor
                    overlayTitleFontSize
                    overlayBgColor
                    seperatorColor
                  }
                  styleType
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryCardDescription
                  coverStoryCardDescription_Te
                  coverStoryCardDescription_En
                  coverStoryCardDescription_Hi
                  textColor
                  backGroundTitle
                  contentTitlePosition
                  coverStoryVideoURL
                  youtubeID
                  youtubeVideoOrientation
                  imageTemplate
                  imageTemplateDescription
                  imageTemplateKey
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  contentNewLinkDetails {
                    linkSubText
                    linkAvatar
                    category
                    urlType
                    linkText
                    buttonPositionFromTop
                    buttonPositionFromLeft
                    markdownLabel
                    pageLink
                    pageInfo {
                      PK
                      SK
                      pageValue
                      pageTitle
                      pageThumbnail
                      pageDescription
                      pageTargetArea
                      pageCreatedDateTime
                      pageModifiedDateTime
                      pageLanguage
                      pageSubscriptionStatus
                      pageTemplate
                    }
                    peopleLink
                    peopleInfo {
                      PK
                      SK
                      peopleType
                      peopleName
                      peopleValue
                      peopleCreatedDateTime
                      peopleModifiedDateTime
                      peopleCoverImage
                      peopleProfileImage
                    }
                    listLink
                    listInfo {
                      PK
                      SK
                      listValue
                      listName
                      listName_Te
                      listName_Hi
                      listName_En
                      listThumbnail
                      listStatus
                      listType
                    }
                    collectionLink
                    collectionInfo {
                      PK
                      SK
                      collectionType
                      collectionName
                      collectionValue
                      collectionImage
                      collectionCreatedDateTime
                      collectionModifiedDateTime
                    }
                    videoLink
                    contentLink
                    playstoreLink
                    appstoreLink
                    saavnLink
                    gaanaLink
                    httpsLink
                    buttonStyle
                    buttonPosition
                    tweetType
                    facebookLink
                    trackerLink
                    watchType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                }
                inAppBrowserDetails {
                  coverStoryTitle
                  coverStoryTitle_Te
                  coverStoryTitle_En
                  coverStoryTitle_Hi
                  coverStoryImages {
                    path
                    image
                    copyRight
                    copyRightText
                    shareImage
                  }
                  contentLinkDetails {
                    watchType
                    urlType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }
                  contentNewLinkDetails {
                    linkSubText
                    linkAvatar
                    category
                    urlType
                    linkText
                    buttonPositionFromTop
                    buttonPositionFromLeft
                    markdownLabel
                    pageLink
                    pageInfo {
                      PK
                      SK
                      pageValue
                      pageTitle
                      pageThumbnail
                      pageDescription
                      pageTargetArea
                      pageCreatedDateTime
                      pageModifiedDateTime
                      pageLanguage
                      pageSubscriptionStatus
                      pageTemplate
                    }
                    peopleLink
                    peopleInfo {
                      PK
                      SK
                      peopleType
                      peopleName
                      peopleValue
                      peopleCreatedDateTime
                      peopleModifiedDateTime
                      peopleCoverImage
                      peopleProfileImage
                    }
                    listLink
                    listInfo {
                      PK
                      SK
                      listValue
                      listName
                      listName_Te
                      listName_Hi
                      listName_En
                      listThumbnail
                      listStatus
                      listType
                    }
                    collectionLink
                    collectionInfo {
                      PK
                      SK
                      collectionType
                      collectionName
                      collectionValue
                      collectionImage
                      collectionCreatedDateTime
                      collectionModifiedDateTime
                    }
                    videoLink
                    contentLink
                    playstoreLink
                    appstoreLink
                    saavnLink
                    gaanaLink
                    httpsLink
                    buttonStyle
                    buttonPosition
                    tweetType
                    facebookLink
                    trackerLink
                    watchType
                    instagramLink
                    youtubeLink
                    twitterLink
                    websiteLink
                  }

                  link
                  linkText
                  textColor
                  backGroundTitle
                  contentTitlePosition
                }
                coverStoryType
              }
              mcqDetails {
                mcqTitle
                mcqTitle_Te
                mcqTitle_En
                mcqTitle_Hi
                explanationCardTitle
                explanationCardTitle_Te
                explanationCardTitle_En
                explanationCardTitle_Hi
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }

                mcqImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                mcqCardImages {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                answerExplanation
                answerExplanation_Te
                answerExplanation_En
                answerExplanation_Hi
                answersInfo {
                  id
                  answer
                  answer_Te
                  answer_En
                  answer_Hi
                  image
                  correct
                  ordering
                  weight
                  placeholder
                }
                textColor
              }
              pollDetails {
                pollBgColor
                pollImage {
                  path
                  image
                  copyRight
                  copyRightText
                  shareImage
                }
                pollInfo {
                  pollOptionID
                  choice_Te
                  choice_Hi
                  choice_En
                  votes
                }
                pollPositionFromTop
                selectedPollColor
                textColor
                pollTitle
                pollTitle_Te
                pollTitle_En
                pollTitle_Hi
                pollDescription
                pollDescription_Te
                pollDescription_En
                pollDescription_Hi
                pollOptions
                contentLinkDetails {
                  watchType
                  urlType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
                contentNewLinkDetails {
                  linkSubText
                  linkAvatar
                  category
                  urlType
                  linkText
                  buttonPositionFromTop
                  buttonPositionFromLeft
                  markdownLabel
                  pageLink
                  pageInfo {
                    PK
                    SK
                    pageValue
                    pageTitle
                    pageThumbnail
                    pageDescription
                    pageTargetArea
                    pageCreatedDateTime
                    pageModifiedDateTime
                    pageLanguage
                    pageSubscriptionStatus
                    pageTemplate
                  }
                  peopleLink
                  peopleInfo {
                    PK
                    SK
                    peopleType
                    peopleName
                    peopleValue
                    peopleCreatedDateTime
                    peopleModifiedDateTime
                    peopleCoverImage
                    peopleProfileImage
                  }
                  listLink
                  listInfo {
                    PK
                    SK
                    listValue
                    listName
                    listName_Te
                    listName_Hi
                    listName_En
                    listThumbnail
                    listStatus
                    listType
                  }
                  collectionLink
                  collectionInfo {
                    PK
                    SK
                    collectionType
                    collectionName
                    collectionValue
                    collectionImage
                    collectionCreatedDateTime
                    collectionModifiedDateTime
                  }
                  videoLink
                  contentLink
                  playstoreLink
                  appstoreLink
                  saavnLink
                  gaanaLink
                  httpsLink
                  buttonStyle
                  buttonPosition
                  tweetType
                  facebookLink
                  trackerLink
                  watchType
                  instagramLink
                  youtubeLink
                  twitterLink
                  websiteLink
                }
              }
            }
          }

          storyDetails {
            shortByteTemplateType
            readMoreLink
            showRating
            reviewRating
            storyTitle
            storyTitle_Te
            storyTitle_En
            storyTitle_Hi
            storyYoutubeImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            storyCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            storyCardDescription
            storyCardDescription_Te
            storyCardDescription_En
            storyCardDescription_Hi
            coverStoryVideoURL
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          coverStoryDetails {
            flipToStoryDetails {
              styleType
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              coverStoryCardImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
            }
            onlyCoverDetails {
              advancedOverlayStyles {
                advancedOverlayStyleType
                enableSeperator
                overlayDescriptionBold
                overlayDescriptionColor
                overlayDescriptionFontSize
                overlayPositionFromBottom
                overlayTitleBold
                overlayTitleColor
                overlayTitleFontSize
                overlayBgColor
                seperatorColor
              }
              styleType
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryCardDescription
              coverStoryCardDescription_Te
              coverStoryCardDescription_En
              coverStoryCardDescription_Hi
              textColor
              backGroundTitle
              contentTitlePosition
              coverStoryVideoURL
              youtubeID
              youtubeVideoOrientation
              imageTemplate
              imageTemplateDescription
              imageTemplateKey
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
            }
            inAppBrowserDetails {
              coverStoryTitle
              coverStoryTitle_Te
              coverStoryTitle_En
              coverStoryTitle_Hi
              coverStoryImages {
                image
                copyRight
                copyRightText
                shareImage
              }
              contentLinkDetails {
                watchType
                urlType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }
              contentNewLinkDetails {
                linkSubText
                linkAvatar
                category
                urlType
                linkText
                buttonPositionFromTop
                buttonPositionFromLeft
                markdownLabel
                pageLink
                pageInfo {
                  PK
                  SK
                  pageValue
                  pageTitle
                  pageThumbnail
                  pageDescription
                  pageTargetArea
                  pageCreatedDateTime
                  pageModifiedDateTime
                  pageLanguage
                  pageSubscriptionStatus
                  pageTemplate
                }
                peopleLink
                peopleInfo {
                  PK
                  SK
                  peopleType
                  peopleName
                  peopleValue
                  peopleCreatedDateTime
                  peopleModifiedDateTime
                  peopleCoverImage
                  peopleProfileImage
                }
                listLink
                listInfo {
                  PK
                  SK
                  listValue
                  listName
                  listName_Te
                  listName_Hi
                  listName_En
                  listThumbnail
                  listStatus
                  listType
                }
                collectionLink
                collectionInfo {
                  PK
                  SK
                  collectionType
                  collectionName
                  collectionValue
                  collectionImage
                  collectionCreatedDateTime
                  collectionModifiedDateTime
                }
                videoLink
                contentLink
                playstoreLink
                appstoreLink
                saavnLink
                gaanaLink
                httpsLink
                buttonStyle
                buttonPosition
                tweetType
                facebookLink
                trackerLink
                watchType
                instagramLink
                youtubeLink
                twitterLink
                websiteLink
              }

              link
              linkText
              textColor
              backGroundTitle
              contentTitlePosition
            }
            coverStoryType
          }
          mcqDetails {
            mcqTitle
            mcqTitle_Te
            mcqTitle_En
            mcqTitle_Hi
            explanationCardTitle
            explanationCardTitle_Te
            explanationCardTitle_En
            explanationCardTitle_Hi
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            mcqImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            mcqCardImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            answerExplanation
            answerExplanation_Te
            answerExplanation_En
            answerExplanation_Hi
            answersInfo {
              id
              answer
              answer_Te
              answer_En
              answer_Hi
              image
              correct
              ordering
              weight
              placeholder
            }
            textColor
          }
          pollDetails {
            pollBgColor
            pollImage {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            pollInfo {
              pollOptionID
              choice_Te
              choice_Hi
              choice_En
              votes
            }
            pollPositionFromTop
            selectedPollColor
            textColor
            pollTitle
            pollTitle_Te
            pollTitle_En
            pollTitle_Hi
            pollDescription
            pollDescription_Te
            pollDescription_En
            pollDescription_Hi
            pollOptions
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
          }
          liveNewsSectionDetails {
            readMoreLink
            showRating
            reviewRating
            liveNewsTitle
            liveNewsTitle_Te
            liveNewsTitle_En
            liveNewsTitle_Hi
            createdAs
            createdFrom
            createdDateTime
            modifiedBy
            modifiedDateTime
            liveNewsYoutubeImages {
              path
              image
              copyRight
              copyRightText
              shareImage
            }
            liveNewsImages {
              image
              copyRight
              copyRightText
              shareImage
            }
            liveNewsVideoURL
            liveNewsYoutubeID
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
            contentLinkDetails {
              watchType
              urlType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }
            contentNewLinkDetails {
              linkSubText
              linkAvatar
              category
              urlType
              linkText
              buttonPositionFromTop
              buttonPositionFromLeft
              markdownLabel
              pageLink
              pageInfo {
                PK
                SK
                pageValue
                pageTitle
                pageThumbnail
                pageDescription
                pageTargetArea
                pageCreatedDateTime
                pageModifiedDateTime
                pageLanguage
                pageSubscriptionStatus
                pageTemplate
              }
              peopleLink
              peopleInfo {
                PK
                SK
                peopleType
                peopleName
                peopleValue
                peopleCreatedDateTime
                peopleModifiedDateTime
                peopleCoverImage
                peopleProfileImage
              }
              listLink
              listInfo {
                PK
                SK
                listValue
                listName
                listName_Te
                listName_Hi
                listName_En
                listThumbnail
                listStatus
                listType
              }
              collectionLink
              collectionInfo {
                PK
                SK
                collectionType
                collectionName
                collectionValue
                collectionImage
                collectionCreatedDateTime
                collectionModifiedDateTime
              }
              videoLink
              contentLink
              playstoreLink
              appstoreLink
              saavnLink
              gaanaLink
              httpsLink
              buttonStyle
              buttonPosition
              tweetType
              facebookLink
              trackerLink
              watchType
              instagramLink
              youtubeLink
              twitterLink
              websiteLink
            }

            liveNewsDescription
            liveNewsDescription_Te
            liveNewsDescription_En
            liveNewsDescription_Hi
            liveNewsVideoURL
            liveNewsYoutubeID
            youtubeID
            youtubeVideoOrientation
            imageTemplate
            imageTemplateDescription
            imageTemplateKey
          }
          content
          questionHint
          contentImage
          questionType
          link
          linkText
          published
          explanation
          explanationImages

          userExplanation
          wrongAnswerText
          rightAnswerText
          createdDate
          answersInfo {
            correct
            ordering
            placeholder
            weight
            answer
            answer_Te
            answer_En
            answer_Hi
            image
          }
        }
      }
      nextToken
    }
  }
`

export const listLuckyDrawUsers = gql`
  query(
    $filterBy: String
    $luckydrawName: String
    $fromTime: Int
    $toTime: Int
    $limit: Int
    $nextToken: String
    $mobileNumber: String
  ) {
    listLuckyDrawUsers(
      filterBy: $filterBy
      luckydrawName: $luckydrawName
      fromTime: $fromTime
      toTime: $toTime
      limit: $limit
      nextToken: $nextToken
      mobileNumber: $mobileNumber
    ) {
      items {
        PK
        SK
        name
        handle
        mobileNumber
        luckydrawURL
        luckydrawName
        luckydrawByUUID
        luckydrawByName
        luckydrawByHandle
        luckydrawByMobileNumber

        luckydrawRecordCreatedTime
        userAppInstalledTime
      }
      nextToken
    }
  }
`
export const listCricketTeams = gql`
  query listCricketTeams($limit: Int, $nextToken: String) {
    listCricketTeams(limit: $limit, nextToken: $nextToken) {
      items {
        PK
        SK
        teamName
        teamLogo
        teamImage
        teamShortName
      }
    }
  }
`
export const listFeaturedMatches = gql`
  query listFeaturedMatches($tournamentKey: String) {
    listFeaturedMatches(tournamentKey: $tournamentKey) {
      matchesInfo
    }
  }
`
export const listAssociations = gql`
  query listAssociations {
    listAssociations {
      associationsInfo
    }
  }
`

export const listAssociationFeaturedTournaments = gql`
  query listAssociationFeaturedTournaments($associationKey: String) {
    listAssociationFeaturedTournaments(associationKey: $associationKey) {
      tournamentsInfo
    }
  }
`
export const listReferralAnalytics = gql`
  query(
    $filterBy: String
    $mobileNumber: String
    $fromTime: Int
    $toTime: Int
    $limit: Int
    $nextToken: String
  ) {
    listReferralAnalytics(
      filterBy: $filterBy
      fromTime: $fromTime
      toTime: $toTime
      limit: $limit
      nextToken: $nextToken
      mobileNumber: $mobileNumber
    ) {
      items {
        PK
        SK
        referralUUID
        referralURLType
        referralURL
        referralUserType
        referredByUUID
        referralInstallTime
        referredByUserMobileNumber
        referredByUserName
        referredByUserHandle
        referralUserMobileNumber
        referralUserName
        referralUserHandle
      }
      nextToken
    }
  }
`
export const getContentCreatorsAndPlanners = gql`
  query getContentCreatorsAndPlanners {
    getContentCreatorsAndPlanners {
      items {
        PK
        SK
        name
        handle
      }
    }
  }
`
export const getCreatorsPointsReport = gql`
  query($filterBy: String, $fromTime: Int, $toTime: Int) {
    getCreatorsPointsReport(filterBy: $filterBy, fromTime: $fromTime, toTime: $toTime) {
      items {
        PK
        name
        handle
        creatorPoints
        creatorLikePoints
        creatorBookmarkPoints
        creatorPnOpensPoints
        plannerPoints
        plannerLikePoints
        plannerBookmarkPoints
        plannerPnOpensPoints
        creatorTotalLikes
        creatorTotalBookmarks
        creatorTotalPnOpens
        creatorTotalContentsPublished
        creatorExtraArticlesPoints
        plannerTotalLikes
        plannerTotalBookmarks
        plannerTotalPnOpens
        plannerTotalContentsPublished
        plannerExtraArticlesPoints
      }
    }
  }
`
export const searchContentMedia = gql`
  query($from: Int, $limit: Int, $search: String) {
    searchContentMedia(from: $from, limit: $limit, search: $search) {
      items {
        PK
        SK
        image
        copyRightText
        contentDescription
        contentDescriptionInLowerCase
        contentDescription_Te
        contentDescription_TeInLowerCase
        contentDescription_En
        contentDescription_EnInLowerCase
        contentDescription_Hi
        contentDescription_HiInLowerCase
      }
      total
    }
  }
`

export const getJobConfig = gql`
  query getJobConfig {
    getJobConfig {
      jobConfig {
        jobSkills
        jobQualifications
        workType
        jobLocations {
          mainLocation
          subLocations
        }
        salaryRange
        experienceRange
        jobCategory
        jobType
        jobSector
      }
    }
  }
`

export const listRegisteredCompanies = gql`
  query($limit: Int, $search: String) {
    listRegisteredCompanies(limit: $limit, search: $search) {
      items {
        PK
        SK
        companyName
        companyBio
        companyAddress
        companyEmail
        phoneNumber
        GST
        companyLogo
        companyWebsite
        displayMobileNumberInJobPost
        contactName
        jobApplicationLink
      }
      nextToken
    }
  }
`
export const getBlobFormatForImage = gql`
  query($key: String!) {
    getBlobFormatForImage(key: $key) {
      blobObject
    }
  }
`

export const getPerson = gql`
  query($PK: String) {
    getPerson(PK: $PK) {
      status
      PK
      SK
      yousayArticleReviews {
        articleReviewTitle_En
        articleReviewTitle_Te
        articleReviewURL_En
        articleReviewURL_Te
      }
      achievementsAndHonors {
        answerItems_En {
          awardYear
          awardTitle_En
          awardTitle_Te
          awardsBasicInfo_En
          awardsBasicInfo_Te
        }
        answerItems_Te {
          awardYear
          awardTitle_En
          awardTitle_Te
          awardsBasicInfo_En
          awardsBasicInfo_Te
        }
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
      }
      personNewsUpdates {
        status
        moderatorHandle
        moderatorID
        publishedDate
        publishedTime
        description_En
        description_Te
        source
        personID
        movieID
        title_En
        name_En
      }
      career {
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
        answerItems_En {
          title
          path
          videoPlatform
        }
      }
      personalAndBackgroundInfo {
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
      }
      politicsInfo {
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
      }
      rumorsAndControversies {
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
      }
      familyAndRelationships {
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
      }
      businessVentures {
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
      }
      personalAssetsAndSocialMedia {
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
        answerItems_En {
          instaLink
          twitterLink
          youtubeChannelLink
        }
      }
      favourites {
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
      }
      familyAndRelationships {
        question_En
        answer_En
        field_En
        question_Te
        answer_Te
        field_Te
      }
      about
      about_Te
      internalComments
      rumours
      tags
      adminTagsGood
      adminTagsBad
      controversies
      awards_TFIDB
      about_En
      almamater
      awards
      birthName
      children
      constituency
      contentType
      currentlyActive
      dateOfBirth
      died
      education
      imageLink
      family
      genres
      honours
      imageLink
      instruments
      labels
      memberOf
      name
      roles
      nationality
      nickName
      notableWork
      occupation
      origin
      otherNames
      otherPoliticalAffiliations
      parents
      personID
      personURL
      placeOfBirth
      politicalParty
      posterURL
      precededBy
      relatives
      residence
      spouse
      succeededBy
      title
      website
      works
      yearsActive
      movieRole
      almamater_En
      almamater_Te
      awards_En
      awards_Te
      birthName_En
      birthName_Te
      children_En
      children_Te
      constituency_En
      constituency_Te
      education_En
      education_Te
      family_En
      family_Te
      genres_En
      genres_Te
      honours_En
      honours_Te
      labels_En
      labels_Te
      memberOf_En
      memberOf_Te
      name_En
      name_Te
      nickName_En
      nickName_Te
      notableWork_En
      notableWork_Te
      occupation_En
      occupation_Te
      origin_En
      origin_Te
      otherNames_En
      otherNames_Te
      otherPoliticalAffiliations_En
      otherPoliticalAffiliations_Te
      parents_En
      parents_Te
      placeOfBirth_En
      placeOfBirth_Te
      politicalParty_En
      politicalParty_Te
      precededBy_En
      precededBy_Te
      relatives_En
      relatives_Te
      spouse_En
      spouse_Te
      succeededBy_En
      succeededBy_Te
      works_En
      works_Te
      residence_Te
      residence_En
      instruments
      instruments_Te
      personWikiURL
      instruments_En
      popularPerson
      GOAT
      popularyKnownAs_En
      popularyKnownAs_Te
      firstMovie {
        movieID
        PK
        SK
        title_En
        title_Te
        posterURL
      }
      firstSuccessfulMovie {
        movieID
        PK
        SK
        title_En
        title_Te
        posterURL
      }
      hitMovies {
        PK
        SK
        title_En
        title_Te
        movieID
        posterURL
      }
      instagramLink
      readMoreAboutLink
      twitterID
      age
      education_TFIDB
      height
      spouse_TFIDB {
        isAnonymous
        personID
        name_En
        name_Te
        posterURL
      }
      parents_TFIDB {
        isAnonymous
        personID
        name_En
        name_Te
        posterURL
      }
      relatives_TFIDB {
        isAnonymous
        personID
        name_En
        name_Te
        posterURL
      }
      children_TFIDB {
        isAnonymous
        personID
        name_En
        name_Te
        posterURL
      }
      firstMovie {
        movieID
        PK
        SK
        posterURL
      }
      firstSuccessfulMovie {
        movieID
        PK
        SK
        posterURL
      }
      hitMovies {
        PK
        SK
        movieID
        posterURL
      }
      galleryImages {
        path
        title
        galleryTags
      }
      galleryVideos {
        path
        title
        thumbnail
        galleryTags
        videoPlatform
      }

      personActed {
        allMoviesReleasedDate
        movieID
        movieRole
      }
    }
  }
`

export const getMovie = gql`
  query($movieID: String) {
    getMovie(PK: $movieID) {
      status
      PK
      SK
      yousayArticleReviews {
        articleReviewTitle_En
        articleReviewTitle_Te
        articleReviewURL_En
        articleReviewURL_Te
        articleReviewDescription_En
        articleReviewDescription_Te
        articleReviewRating
      }
      sendTFIDBPN
      PNInfo {
        title_En
        title_Te
        description_En
        description_Te
        posterURL
      }
      movieAndOTTNewsUpdates {
        status
        moderatorHandle
        moderatorID
        publishedDate
        publishedTime
        description_En
        description_Te
        source
        personID
        movieID
        title_En
        name_En
      }
      OTTPlatformsWithLangs {
        availablePlatform
        availableLanguages
      }
      movieStatus
      OTTStatus
      ageRestriction
      tags
      adminTagsGood
      adminTagsBad
      allMoviesReleasedDate
      about_En
      about_Te
      yousayRating
      boxOffice
      budget
      contentType
      country
      createdDate
      createdTime
      distributedBy
      distributedBy_Te
      distributedBy_En
      genre_En
      genre_Te
      contentType
      GSIAllMovies
      GSIOTTMovies
      GSITheatreMovies
      GSIAllDateAndRating
      GSIMovieDateAndRating
      GSIOTTDateAndRating
      GSIStatusAndContentType
      imageLink
      language
      movieID
      allMoviesReleasedDate
      movieReleasedDate
      movieReleasedDateUI
      narratedBy
      narratedBy_En
      narratedBy_Te
      ottPlatform
      ottReleasedDate
      ottReleasedDateUI
      posterURL
      movieRatingAdminPanel
      productionCompany
      basedOn_En
      basedOn_Te
      productionCompany_En
      productionCompany_Te
      movieRating
      youtubeLink
      zee5Link
      sunNextLink
      sonyLiv
      primeLink
      netflixLink
      hotstarLink
      jioCinemaLink
      mxPlayer
      etvApp
      ahaLink
      runningTime
      movieReleasedDate
      wikipediaLink
      title
      title_En
      title_Te
      noOfEpisodes
      popularMovie
      GOAT
      originalLanguageTelugu
      internalComments
      galleryImages {
        path
        title
      }
      galleryVideos {
        path
        title
        thumbnail
      }

      Cast {
        PK
        SK
        isAnonymous
        name_Te
        name_En
        personID
        personUUID
        personType
        roleName_En
        roleName_Te
        movieRole
        movieRole_En
        movieRole_Te
        posterURL
        GSIPersonStatusAndPersonID
        weight
      }
      Crew {
        PK
        SK
        isAnonymous
        name_En
        name_Te
        personID
        personUUID
        personType
        roleName
        movieRole
        movieRole_En
        movieRole_Te
        posterURL
        weight
        position
        weightAndPosition
        GSIPersonStatusAndPersonID
      }
    }
  }
`

export const autoSuggestions = gql`
  query($search: String!, $type: String, $limit: Int, $from: Int, $status: filterStatusType) {
    getAutoSuggestionsForMoviesAndPerson(
      search: $search
      type: $type
      limit: $limit
      from: $from
      status: $status
    ) {
      movieHits {
        status
        cast_En {
          character
          name
          name_En
          name_Te
          id
        }
        cast_Te {
          character
          name
          name_En
          name_Te
          id
        }
        PK
        SK
        movieID
        about
        about_En
        about_Te
        title_En
        title_Te
        posterURL
        movieReleasedDate
        ageRestriction
        contentType
      }
      totalMovieCount
      filteredGenre {
        key
        count
      }
      filteredOtt {
        key
        count
      }
      filteredMovieRating {
        key
        count
      }
      filteredAgeRestriction {
        key
        count
      }
      personHits {
        PK
        SK
        about_En
        about_Te
        almamater_En
        almamater_Te
        awards_En
        awards_Te
        birthName_En
        birthName_Te
        children_En
        children_Te
        constituency_En
        constituency_Te
        contentType
        createdDate
        createdTime
        currentlyActive
        dateOfBirth
        died
        education_En
        education_Te
        family_En
        family_Te
        genres_En
        genres_Te
        honours_En
        honours_Te
        imageLink
        instruments_En
        instruments_Te
        labels_En
        labels_Te
        memberOf_En
        memberOf_Te
        name_En
        name_Te
        nationality
        nickName_En
        nickName_Te
        notableWork_En
        notableWork_Te
        occupation_En
        occupation_Te
        origin_En
        origin_Te
        otherNames_En
        otherNames_Te
        otherPoliticalAffiliations_En
        otherPoliticalAffiliations_Te
        parents_En
        parents_Te
        personID
        personUUID
        personWikiURL
        placeOfBirth_En
        placeOfBirth_Te
        politicalParty_En
        politicalParty_Te
        posterURL
        precededBy_En
        precededBy_Te
        relatives_En
        relatives_Te
        residence_En
        residence_Te
        roles
        spouse_En
        spouse_Te
        status
        succeededBy_En
        succeededBy_Te
        title_En
        title_Te
        website
        works_En
        works_Te
        yearsActive
        personWikiURL
        allWikiOriginals
        contentType
      }
      totalPersonCount
    }
  }
`

export const giveMovieDetailsFromWikiPedia = gql`
  query {
    giveMovieDetailsFromWikiPedia {
      items {
        PK
        SK
        movieID
        about
        about_En
        about_Te
        ageRestriction
        ahaLink
        allMoviesReleasedDate
        basedOn
        basedOn_En
        basedOn_Te
        boxOffice
        budget
        contentType
        country
        distributedBy
        distributedBy_En
        distributedBy_Te
        etvApp
        genre
        GSIContentTypeMovieRating
        GSIAllMovies
        GSIOTTMovies
        GSITheatreMovies
        hotstarLink
        imageLink
        language
        movieID
        movieRating
        allMoviesReleasedDate
        narratedBy
        narratedBy_En
        narratedBy_Te
        netflixLink
        ottPlatform
        ottReleasedDate
        posterURL
        primeLink
        productionCompany
        productionCompany_En
        productionCompany_Te
        runningTime
        sonyLiv
        sunNextLink
        title
        title_En
        title_Te
        wikipediaLink
        youtubeLink
        zee5Link
        crew_En {
          name
          id
          movieRole
        }
        cast_En {
          character
          name
          id
        }
        cast_Te {
          character
          name
          id
        }
        crew_Te {
          name
          id
          movieRole
        }
        crew_En_orphan {
          character
          name
        }
        cast_En_orphan {
          movieRole
          name
        }
      }
    }
  }
`

export const filterperson = gql`
  query(
    $search: String
    $personFilterBy: personFilterByInput
    $type: String
    $from: Int
    $limit: Int
  ) {
    filterMoviesAndPersonsV2(
      limit: $limit
      from: $from
      search: $search
      type: $type
      personFilterBy: $personFilterBy
    ) {
      items {
        PK
        SK
        about_En
        about_Te
        almamater_En
        almamater_Te
        awards_En
        awards_Te
        birthName_En
        birthName_Te
        children_En
        children_Te
        constituency_En
        constituency_Te
        contentType
        createdDate
        createdTime
        currentlyActive
        dateOfBirth
        tags
        adminTagsGood
        adminTagsBad
        died
        education_En
        education_Te
        family_En
        family_Te
        genres_En
        genres_Te
        honours_En
        honours_Te
        imageLink
        instruments_En
        instruments_Te
        labels_En
        labels_Te
        memberOf_En
        memberOf_Te
        name_En
        name_Te
        nationality
        nickName_En
        nickName_Te
        notableWork_En
        notableWork_Te
        occupation_En
        occupation_Te
        origin_En
        origin_Te
        otherNames_En
        otherNames_Te
        otherPoliticalAffiliations_En
        otherPoliticalAffiliations_Te
        parents_En
        parents_Te
        personID
        personUUID
        personType
        personWikiURL
        placeOfBirth_En
        placeOfBirth_Te
        politicalParty_En
        politicalParty_Te
        posterURL
        precededBy_En
        precededBy_Te
        relatives_En
        relatives_Te
        residence_En
        residence_Te
        roles
        spouse_En
        spouse_Te
        status
        succeededBy_En
        succeededBy_Te
        title_En
        title_Te
        website
        works_En
        works_Te
        yearsActive
      }
      total
    }
  }
`

export const Listperson = gql`
  query($status: String, $limit: Int, $nextToken: String) {
    listPersons(status: $status, limit: $limit, nextToken: $nextToken) {
      items {
        PK
        SK
        personID
        personUUID
        almamater_En
        almamater_Te
        awards_En
        awards_Te
        birthName_En
        birthName_Te
        children_En
        children_Te
        constituency_En
        constituency_Te
        contentType
        currentlyActive
        died
        education_En
        education_Te
        family_En
        family_Te
        genres_En
        genres_Te
        personType
        honours_En
        honours_Te
        instruments_En
        instruments_Te
        labels_En
        labels_Te
        memberOf_En
        memberOf_Te
        name_En
        name_Te
        about_En
        about_Te
        dateOfBirth
        type
        placeOfBirth_En
        placeOfBirth_Te
        nationality
        nickName_En
        nickName_Te
        notableWork_En
        notableWork_Te
        occupation_En
        occupation_Te
        origin_En
        origin_Te
        otherNames_En
        otherNames_Te
        otherPoliticalAffiliations_En
        otherPoliticalAffiliations_Te
        parents_En
        parents_Te
        personWikiURL
        politicalParty_En
        politicalParty_Te
        posterURL

        precededBy_En
        precededBy_Te
        relatives_En
        relatives_Te
        residence_En
        residence_Te
        spouse_En
        spouse_Te
        succeededBy_En
        succeededBy_Te
        title_En
        title_Te
        website
        works_En
        works_Te
        yearsActive
        status
      }
      nextToken
    }
  }
`
export const wikipedia = gql`
  query($movieWikiURL: String!, $mode: movieMode!) {
    getMovieDatabyScrapingWikiURL(input: { movieWikiURL: $movieWikiURL, mode: $mode }) {
      movieData {
        title_En
        about_En
        #noOfEpisodes
        directedBy_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        writtenBy_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        producedBy_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        cinematography_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        editedBy_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        musicBy_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        productioncompany_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        storyBy_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        dialogueBy_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        distributedBy_En {
          name_En
          name_Te
          personID
          movieRole
          posterURL
        }
        cast_En {
          name_En
          name_Te
          personID
          role
          posterURL
        }
        movieReleasedDate
        runningTime
        country
        language
        posterURL
        budget
        boxOffice
      }
      movieAndPersons {
        name_En
        personWikiURL
        about_En
        dateOfBirth
        posterURL
        placeOfBirth_En
        spouse_En
        yearsActive
        otherNames_En
        almamater_En
        currentlyActive
        instruments_En
        occupation_En
        residence_En
        parents_En
        industry
        founded
        founders
        headquarters
        products
        subsidiaries
        owner
        services
        commercial
        registration
        users
        launched
        nationality
        died
        spouse_En
        children_En
        awards_En
        height
        president
        relatives_En
        family_En
        constituency_En
        subscribers
        fate
        labels_En
        genres_En
        language
        precededBy_En
        succeededBy_En
        totalViews
        primeMinister
        politicalParty_En
        otherPoliticalAffiliations_En
        nickName_En
        honours_En
        works_En
        origin_En
        education_En
        birthName_En
        title_En
        notableWork_En
        period
        areaServed
        keyPeople
        alsoKnownAs
        majorCompetitions
        vicePresident
        memberOfParliament_RajyaSabha
        term
        office
        andhraPradeshLegislativeAssembly
        numberOfEmployees
        website
        divisions
        operatingIncome
        type
        wins
        nominations
        citizenship
      }
    }
  }
`

export const givePersondata = gql`
  query {
    getPersonDetails {
      allPersons {
        PK
        SK
        about
        about_Te
        about_En
        almamater
        awards
        birthName
        children
        constituency
        contentType
        currentlyActive
        dateOfBirth
        died
        education
        imageLink
        family
        genres
        honours
        imageLink
        instruments
        labels
        memberOf
        name
        nationality
        nickName
        notableWork
        occupation
        origin
        otherNames
        otherPoliticalAffiliations
        parents
        personID
        personURL
        placeOfBirth
        politicalParty
        posterURL
        precededBy
        relatives
        residence
        spouse
        succeededBy
        title
        website
        works
        yearsActive
        movieRole
        almamater_En
        almamater_Te
        awards_En
        awards_Te
        birthName_En
        birthName_Te
        children_En
        children_Te
        constituency_En
        constituency_Te
        education_En
        education_Te
        family_En
        family_Te
        genres_En
        genres_Te
        honours_En
        honours_Te
        labels_En
        labels_Te
        memberOf_En
        memberOf_Te
        name_En
        name_Te
        nickName_En
        nickName_Te
        notableWork_En
        notableWork_Te
        occupation_En
        occupation_Te
        origin_En
        origin_Te
        otherNames_En
        otherNames_Te
        otherPoliticalAffiliations_En
        otherPoliticalAffiliations_Te
        parents_En
        parents_Te
        placeOfBirth_En
        placeOfBirth_Te
        politicalParty_En
        politicalParty_Te
        precededBy_En
        precededBy_Te
        relatives_En
        relatives_Te
        spouse_En
        spouse_Te
        succeededBy_En
        succeededBy_Te
        works_En
        works_Te
        residence_Te
        residence_En
        instruments
        instruments_Te
        instruments_En
      }
    }
  }
`
//
export const getlistMovies = gql`
  query(
    $contentType: contentType
    $type: String
    $sortBy: String
    $status: String
    $filters: listMoviesFiltersInput
    $nextToken: String
    $limit: Int
  ) {
    listMovies(
      contentType: $contentType
      nextToken: $nextToken
      type: $type
      sortBy: $sortBy
      filters: $filters
      limit: $limit
      status: $status
    ) {
      items {
        PK
        SK
        movieID
        posterURL
        title_En
        title_Te
        about_En
        about_Te
        movieReleasedDateUI
        ottReleasedDate
        allMoviesReleasedDate
        movieDirectedBy {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }
        movieProducedBy {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }
        movieCast {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }
        movieCinematography {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }

        movieEditedBy {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }

        movieMusicBy {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }

        movieDialogueBy {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }

        movieWrittenBy {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }

        movieScreenplayBy {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }

        movieStoryBy {
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
        }
        ottPlatform
        netflixLink
        primeLink
        sonyLiv
        sunNextLink
        wikipediaLink
        youtubeLink
        zee5Link
        ahaLink
        jioCinemaLink
        etvApp
        ageRestriction
        noOfEpisodes
        yousayRating
        basedOn_En
        basedOn_Te
        boxOffice
        budget
        contentType
        country
        distributedBy_En
        distributedBy_Te
        genre_En
        genre_Te
        hotstarLink
        language
        movieID
        movieRating

        narratedBy_En
        narratedBy_Te

        productionCompany_En
        productionCompany_Te
        runningTime
      }
      nextToken
    }
  }
`

export const filterMoviesAndPersons = gql`
  query(
    $limit: Int
    $from: Int
    $search: String
    $sortBy: String
    $type: String
    $movieFilterBy: movieFilterByInputV2
    $sortOrder: String
  ) {
    filterMoviesAndPersonsV2(
      limit: $limit
      from: $from
      search: $search
      sortBy: $sortBy
      sortOrder: $sortOrder
      type: $type
      movieFilterBy: $movieFilterBy
    ) {
      total
      items {
        noOfEpisodes
        PK
        SK
        isBasicValidationDone
        isExtendedValidationDone
        allMoviesReleasedDate
        boxOffice
        budget
        sendTFIDBPN
        contentType
        contentSubType
        country
        createdDate
        createdTime
        distributedBy_En
        distributedBy_Te
        language
        imageLink
        movieID
        narratedBy_En
        narratedBy_Te
        ottReleasedDate
        ottReleasedDateUI
        productionCompany_En
        productionCompany_Te
        runningTime
        status
        tags
        adminTagsGood
        adminTagsBad
        movieReleasedDate
        movieReleasedDateUI
        posterURL
        title_En
        title_Te
        about_En
        about_Te
        genre_Te
        genre_En
        ageRestriction
        ottPlatform
        ahaLink
        hotstarLink
        netflixLink
        primeLink
        youtubeLink
        zee5Link
        sonyLiv
        sunNextLink
        jioCinemaLink
        wikipediaLink
        etvApp
        movieRating
        galleryImages {
          path
          title
        }
        galleryVideos {
          path
          title
        }

        movieCast {
          weight
          createdDate
          createdTime
          personUUID
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          roleName_Te
          roleName_En
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }
        movieProducedBy {
          createdDate
          createdTime
          personUUID
          weight
          position
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }

        movieCinematography {
          createdDate
          createdTime
          personUUID
          weight
          position
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }

        movieDirectedBy {
          createdDate
          createdTime
          personUUID
          weight
          position
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }

        movieEditedBy {
          createdDate
          createdTime
          personUUID
          weight
          position
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }

        movieMusicBy {
          createdDate
          createdTime
          personUUID
          weight
          position
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }

        movieDialogueBy {
          createdDate
          createdTime
          personUUID
          weight
          position
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }

        movieWrittenBy {
          createdDate
          createdTime
          personUUID
          weight
          position
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }

        movieScreenplayBy {
          createdDate
          createdTime
          personUUID
          position
          weight
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }

        movieStoryBy {
          createdDate
          createdTime
          personUUID
          weight
          position
          isAnonymous
          name_En
          name_Te
          personID
          posterURL
          PK
          SK
          movieRole_En
          movieRole_Te
          GSIPersonStatusAndPersonID
        }
      }
    }
  }
`

export const GetPreSignedURLForMovieUploads = gql`
  query($key: String!, $mimeType: String!) {
    getPreSignedURLForMovieUploads(key: $key, mimeType: $mimeType) {
      signedObject
      statusCode
    }
  }
`
//
export const GetMovieListService = gql`
  query(
    $filterBy: movieListFilter!
    $movieListCategory: movieListCategory
    $movieListType: movieListType
    $limit: Int
    $nextToken: String
    $status: String
  ) {
    getMovieLists(
      filterBy: $filterBy
      movieListCategory: $movieListCategory
      movieListType: $movieListType
      limit: $limit
      nextToken: $nextToken
      status: $status
    ) {
      items {
        PK
        SK
        createdByHandle
        createdByID
        movieListCreatedTime
        updatedTime
        movieListID
        title_En
        title_Te
        description_En
        description_Te
        movieListImage
        movieListType
        movieListCategory
        movieListTypeAndCategory
      }
      nextToken
    }
  }
`
export const SearchMovieListsService = gql`
  query($search: String, $from: Int, $limit: Int) {
    searchMovieLists(search: $search, from: $from, limit: $limit) {
      totalMovieListCount
      movieListHits {
        PK
        SK
        createdByHandle
        createdBy
        createdTime
        updatedTime
        movieListID
        title_En
        title_Te
        description_En
        description_Te
        movieListImage
        movieListType
        movieListCategory
        movieListTypeAndCategory
        movieListImage
      }
    }
  }
`

export const GetmoviesAppInfoConfig = gql`
  query getMoviesAppInfoConfig {
    getMoviesAppInfoConfig {
      PK
      SK
      siteColour
      genres {
        label
        label_Te
        value_Te
        value
      }
      genreListFilters {
        label
        label_Te
        value_Te
        value
      }
      filterItemsTabs {
        label
        value
      }
      mobilefilterItemsTabs {
        label
        value
      }
      fixedFilterItemsTabs {
        label
        value
      }
      ageRestrictionFilters {
        label
        value
      }
      movieBasicValidation
      movieExtendedValidation
      ottList {
        label
        url
      }
      ottListFilters {
        label
        value
      }
      otherMovieFilters {
        label
        value
      }
      ageRestrictions {
        label
        value
      }
      ageRestrictionFilters {
        label
        value
      }
      personBasicValidation
      personExtendedValidation
      providers
      ratings {
        label
        rating
      }
      engMonthNames
      teluguMonthNames
      ottLabelIcon
      staticNotFoundImage
    }
  }
`
//
export const getAppInfoAndUserOrGuestDetails = gql`
  query($FCMTokenID: String, $userType: String, $UUID: String, $mobileNumber: String) {
    getAppInfoAndUserOrGuestDetails(
      FCMTokenID: $FCMTokenID
      userType: $userType
      UUID: $UUID
      mobileNumber: $mobileNumber
    ) {
      showNpsSurvey
      unReadConversationsCount
      videoCreatorRequestStatus
      languages
      defaultLangIfContentInEnAndTe
      userProfileWalkThroughShown
      creatorProfileWalkThroughShown
      defaultLanguageOfYourVideoContent
      followersToPromote
      showAppReview
      userAppLanguage
      appConfig {
        npsSurveyConfig {
          npsAfterNoOfNews
          npsAfternDaysOfSubmission
          npsAfternDaysOfCancellation
          npsAfterAppInstalledTime
        }
        luckyDrawURLS
        minimumRewardsToRedeem
        referralRewardScreenActiveTill
        explorePageID
        checkUploadVideoPermissions
        googleAdsConfig {
          afterNoOfSwipes
          videoAds
          imageAds
        }
        videoDurations {
          shortVideoDuration {
            maxDuration
            minDuration
          }
        }

        maxAppReviewsPerDay
        noOfFollowersToPromote
        appReviewAfternDays
      }

      newUserMessages
      appReviewTimes
      lastAccessedDateTime
      appReviewStatus
      appInstalledDate
      appReviewSubmittedDateTime
      appReviewCancelledDateTime
      name
      handle
      mobileNumber
      deviceNotificationOnOff
      Stats {
        followersCount
        followingCount
        videosPublishedCount
        noOfVideoViews
      }
      usersAutoUpgrade
      androidplaystorereleases {
        releaseNumber
        versionCode
        forceUpgrade
        currentPlayStoreVersion
      }
      currentAssestsVersion
      userPrivacyandTermsversions {
        termsVersion
        privacyVersion
      }
      currentPrivacyandTermsversions {
        termsVersion
        privacyVersion
      }
      deviceNotificationOnOff
      displayRewardsScreen
    }
  }
`
export const ListUsersinES = gql`
  query listUsersInES($from: Int, $limit: Int, $search: String, $currentLoggedInUserID: String) {
    listUsersInES(
      from: $from
      limit: $limit
      search: $search
      currentLoggedInUserID: $currentLoggedInUserID
    ) {
      items {
        PK
        SK
        name
        handle
        mobileNumber
        userStatus
        userRolesAndPermissions {
          permissions {
            name
            selected
          }
          roleName
        }
      }
      loggedInUserFollowings
      loggedInUserFollowers
    }
  }
`
export const userPermissions = gql`
  query {
    getAppInfo {
      rolesAndPermissions {
        permissions {
          name
          active
        }
        roleName
      }
    }
  }
`
export const listUserPermissions = gql`
  query {
    listUsers {
      items {
        PK
        SK
        name
        handle
        mobileNumber
        userStatus
        userRolesAndPermissions {
          permissions {
            name
            selected
          }
          roleName
        }
      }
    }
  }
`
export const getMovieListDetails = gql`
  query($movieListID: String!) {
    getMovieListDetails(movieListID: $movieListID) {
      items {
        PK
        SK
        youtubeEmbedLink
        listItemTitle_Te
        listItemTitle_En
        listItemImage
        priority
        description
        ageRestriction
        allMoviesReleasedDate
        about_En
        about_Te
        listItemDescription_En
        listItemDescription_Te
        boxOffice
        budget
        contentType
        country
        createdDate
        createdTime
        distributedBy
        distributedBy_Te
        distributedBy_En
        genre_En
        GSIAllMovies
        GSIOTTMovies
        GSITheatreMovies
        GSIAllDateAndRating
        GSIMovieDateAndRating
        GSIOTTDateAndRating
        GSIStatusAndContentType
        imageLink
        language
        movieID
        allMoviesReleasedDate
        movieReleasedDate
        movieReleasedYear
        narratedBy
        narratedBy_En
        narratedBy_Te
        ottPlatform
        ottReleasedDate
        posterURL
        productionCompany
        productionCompany_En
        productionCompany_Te
        movieRating
        youtubeLink
        zee5Link
        sunNextLink
        sonyLiv
        primeLink
        netflixLink
        hotstarLink
        etvApp
        ahaLink
        runningTime
        movieReleasedDate
        wikipediaLink
        title
        title_En
        name_En
        title_Te
        galleryImages {
          path
          title
        }
        galleryVideos {
          path
          title
        }
      }
    }
  }
`
export const getMovieList = gql`
  query($movieListID: String!) {
    getMovieList(movieListID: $movieListID) {
      movieListID
      PK
      SK
      createdByHandle
      createdByID
      description_En
      description_Te
      movieListCategory
      movieListCreatedTime
      movieListType
      movieListTypeAndCategory
      title_En
      title_Te
      movieListLiked
      movieListImage
      movieListStatus
    }
  }
`
export const getTaggedPersonsInMovieList = gql`
  query($movieListID: String!, $limit: Int!) {
    getTaggedPersonsInMovieList(movieListID: $movieListID, limit: $limit) {
      personInfo {
        PK
        SK
        personType
        about_Te
        about_En
        birthdayMonthAndDate
        birthYear
        contentType
        currentlyActive
        dateOfBirth
        died
        imageLink
        imageLink
        nationality
        personID
        personURL
        posterURL
        website
        yearsActive
        almamater_En
        almamater_Te
        awards_En
        awards_Te
        birthName_En
        birthName_Te
        children_En
        children_Te
        constituency_En
        constituency_Te
        education_En
        education_Te
        family_En
        family_Te
        genres_En
        genres_Te
        honours_En
        honours_Te
        labels_En
        labels_Te
        memberOf_En
        memberOf_Te
        name_En
        name_Te
        nickName_En
        nickName_Te
        notableWork_En
        notableWork_Te
        occupation_En
        occupation_Te
        origin_En
        origin_Te
        otherNames_En
        otherNames_Te
        otherPoliticalAffiliations_En
        otherPoliticalAffiliations_Te
        parents_En
        parents_Te
        placeOfBirth_En
        placeOfBirth_Te
        politicalParty_En
        politicalParty_Te
        precededBy_En
        precededBy_Te
        relatives_En
        relatives_Te
        roles
        spouse_En
        spouse_Te
        succeededBy_En
        succeededBy_Te
        works_En
        works_Te
        residence_Te
        residence_En
        roles
        instruments
        instruments_Te
        instruments_En
        galleryImages {
          path
          title
        }
        galleryVideos {
          path
          title
        }
      }
      nextToken
    }
  }
`

export const listMovieCollections = gql`
  query listMovieCollections($status: String, $limit: Int!, $nextToken: String) {
    listMovieCollections(status: $status, limit: $limit, nextToken: $nextToken) {
      items {
        PK
        SK
        title_En
        description_En
        description_Te
        createdByHandle
        createdByID
        movieCollectionCreatedDate
        movieCollectionCreatedTime
        movieCollectionImage
        movieCollectionUpdatedDate
        movieCollectionUpdatedTime
        movieCollectionID
        title_En
        title_Te
        updatedByHandle
        updatedByID
      }
      nextToken
    }
  }
`
export const getMovieCollectionByID = gql`
  query getMovieCollectionByID($movieCollectionID: String!) {
    getMovieCollectionByID(movieCollectionID: $movieCollectionID) {
      title_Te
      title_En
      description_En
      description_Te
      createdByID
      updatedByID
      createdByHandle
      updatedByHandle
      movieCollectionID
      movieCollectionCreatedDate
      movieCollectionCreatedTime
      movieCollectionUpdatedDate
      movieCollectionUpdatedTime
      movieCollectionImage
      movieCollectionStatus
    }
  }
`
export const getListsByMovieCollectionID = gql`
  query getListsByMovieCollectionID($movieCollectionID: String!, $limit: Int!, $nextToken: String) {
    getListsByMovieCollectionID(
      movieCollectionID: $movieCollectionID
      limit: $limit
      nextToken: $nextToken
    ) {
      title_Te
      title_En
      description_En
      description_Te
      createdByID
      updatedByID
      createdByHandle
      updatedByHandle
      movieCollectionID
      movieCollectionCreatedDate
      movieCollectionCreatedTime
      updatedDate
      updatedTime
      movieCollectionStatus
      movieCollectionImage
      publishedDate
      publishedTime
      items {
        PK
        SK
        title_En
        title_Te
        publishedDate
        publishedTime
        createdByHandle
        createdByID
        description_En
        description_Te
        movieListCategory
        movieListCreatedTime
        movieListID
        movieListImage
        movieListType
        movieListTypeAndCategory
        updatedTime
        createdTime
        dynamicListID
        dynamicListImage
        showUpcomingMovies
        castFilterBy
        crewFilterBy
        personID
        movieID
        updatedByHandle
        updatedByID
        dynamicListID
        ageRestriction
        contentType
        dynamicListImage
        dynamicListType
        fromDate
        toDate
        fromRating
        toRating
        genre_En
        genre_Te
        movieRating
        ottPlatform
        sortBy
        dynamicListCreatedDate
        dynamicListCreatedTime
        dynamicListUpdatedDate
        dynamicListUpdatedTime
        popularListType
        popularListCategory
        viewsType
        likesType
        createdDate
        dynamicListStatus
        directedBy_En
        cinematography_En
        editedBy_En
        musicBy_En
        producedBy_En
        writtenBy_En
        dialogueBy_En
        screenplayBy_En
        storyBy_En
        cast_En
      }
      nextToken
    }
  }
`
export const searchListsAndCollectionsMS = gql`
  query(
    $type: searchListType
    $search: String
    $sortBy: String
    $sortOrder: String
    $from: Int
    $limit: Int
  ) {
    searchListsAndCollectionsMS(
      type: $type
      search: $search
      sortBy: $sortBy
      sortOrder: $sortOrder
      from: $from
      limit: $limit
    ) {
      items {
        PK
        SK
        createdByHandle
        createdByID
        dynamicListStatus
        description_En
        description_Te
        movieCollectionCreatedDate
        movieCollectionCreatedTime
        movieCollectionID
        movieCollectionImage
        title_En
        title_Te
        viewCount
        directedBy_En
        cinematography_En
        editedBy_En
        musicBy_En
        producedBy_En
        writtenBy_En
        dialogueBy_En
        screenplayBy_En
        storyBy_En
        cast_En
        contentType
        dynamicListCreatedDate
        dynamicListCreatedTime
        dynamicListID

        dynamicListImage
        dynamicListType
        popularListType
        sortBy
        movieListCategory
        movieListCreatedTime
        movieListID
        movieListImage
        movieListType
        movieListTypeAndCategory
        name
        name_Te
        updatedTime
      }
    }
  }
`
export const listHeaderLevelTaggedPersonsInMovieList = gql`
  query($movieListID: String!, $limit: Int!) {
    listHeaderLevelTaggedPersonsInMovieList(movieListID: $movieListID, limit: $limit) {
      items {
        personID
        name_En
        name_Te
        about_En
        about_Te
      }
      nextToken
    }
  }
`

export const listDynamicLists = gql`
  query listDynamicLists(
    $limit: Int
    $nextToken: String
    $dynamicListType: String!
    $status: String
  ) {
    listDynamicLists(
      limit: $limit
      nextToken: $nextToken
      dynamicListType: $dynamicListType
      status: $status
    ) {
      items {
        PK
        SK
        dynamicListID
        dynamicListImage
        dynamicListStatus
        title_En
        title_Te
        description_En
        description_Te
        createdByHandle
        createdByID
        ageRestriction
        contentType
        dynamicListType
        fromDate
        toDate
        fromRating
        toRating
        genre_En
        movieRating
        ottPlatform
        sortBy
        dynamicListCreatedDate
        dynamicListCreatedTime
        dynamicListUpdatedDate
        dynamicListUpdatedTime
        popularListType
        popularListCategory
        viewsType
        likesType
      }
      nextToken
    }
  }
`

export const getDynamicList = gql`
  query($dynamicListID: String!) {
    getDynamicList(dynamicListID: $dynamicListID) {
      PK
      SK
      limit
      movieID
      personID
      dynamicListID
      title_En
      title_Te
      description_En
      description_Te
      createdByHandle
      createdByID
      ageRestriction
      contentType
      dynamicListImage
      dynamicListType
      fromDate
      toDate
      fromRating
      fromRatingV2
      toRating
      toRatingV2
      genre_En
      movieRating
      ottPlatform
      sortBy
      dynamicListCreatedDate
      dynamicListCreatedTime
      dynamicListUpdatedDate
      dynamicListUpdatedTime
      popularListType
      popularListCategory
      viewsType
      likesType
      directedBy_En
      cinematography_En
      editedBy_En
      musicBy_En
      producedBy_En
      writtenBy_En
      dialogueBy_En
      screenplayBy_En
      storyBy_En
      cast_En
      crewFilterBy
      castFilterBy
      dynamicListStatus
    }
  }
`
export const listHeaderLevelTaggedPersonsInDynamicList = gql`
  query($dynamicListID: String!, $limit: Int!, $nextToken: String) {
    listHeaderLevelTaggedPersonsInDynamicList(
      dynamicListID: $dynamicListID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        personID
        name_En
        name_Te
        about_En
        about_Te
      }
      nextToken
    }
  }
`
export const listHeaderLevelTaggedPersonsInMovieCollection = gql`
  query($movieCollectionID: String!, $limit: Int!, $nextToken: String) {
    listHeaderLevelTaggedPersonsInMovieCollection(
      movieCollectionID: $movieCollectionID
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        personID
        name_En
        name_Te
        about_En
        about_Te
      }
      nextToken
    }
  }
`
export const getDynamicListMovies = gql`
  query getDynamicListMovies($dynamicListID: String, $limit: Int!, $from: Int!) {
    getDynamicListMovies(dynamicListID: $dynamicListID, limit: $limit, from: $from) {
      items {
        PK
        SK
        movieID
        title_En
        title_Te
        about_En
        about_Te
        genre_En
        genre_Te
        ageRestriction
        movieReleasedDate
        movieReleasedDateUI
        ottReleasedDate
        ottReleasedDateUI
        ottPlatform
        movieRating
        posterURL
        viewCount
      }
    }
  }
`

export const getDynamicListMoviesPreview = gql`
  query getDynamicListMovies(
    $limit: Int
    $from: Int
    $preview: Boolean
    $dynamicListInfo: dynamicListInfoInput
  ) {
    getDynamicListMovies(
      limit: $limit
      from: $from
      preview: $preview
      dynamicListInfo: $dynamicListInfo
    ) {
      items {
        PK
        SK
        movieID
        posterURL

        title_En
        title_Te
        about_En
        about_Te
        genre_En
        genre_Te
        ageRestriction
        movieReleasedDate
        movieReleasedDateUI
        ottReleasedDate
        ottReleasedDateUI
        ottPlatform
        movieRating
      }
    }
  }
`

export const getTrendingListsPreview = gql`
  query getTrendingLists(
    $limit: Int
    $dynamicListID: String
    $preview: Boolean
    $dynamicListInfo: dynamicListInfoInput
  ) {
    getTrendingLists(
      limit: $limit
      dynamicListID: $dynamicListID
      preview: $preview
      dynamicListInfo: $dynamicListInfo
    ) {
      items {
        PK
        SK
        movieListID
        movieListImage
        title_En
        title_Te

        description_En
        description_Te
        movieListType
        likes
        dislikes
        movieListCreatedTime
        viewCount
        movieListTypeAndCategory
        movieListCategory

        createdDate
        updatedDate
        updatedTime
      }
    }
  }
`

export const getTrendingLists = gql`
  query($dynamicListID: String!) {
    getTrendingLists(dynamicListID: $dynamicListID) {
      items {
        PK
        SK
        movieListID
        movieListType
        likes
        dislikes
        movieListImage
        movieListCreatedTime
        name
        movieListTypeAndCategory
        movieListCategory
        description
        createdDate
        updatedDate
        updatedTime
      }
    }
  }
`

export const getTFIDBPageJSONService = gql`
  query getTFIDBPageJSON {
    getTFIDBPageJSON {
      PK
      SK
      JSON {
        viewMoreLinkEn
        viewMoreLinkTe
        viewMoreEn
        viewMoreTe
        collectionID
        UIComponentType
        dynamicListID
        displayName

        limit
      }
    }
  }
`

export const getTFIDBPageJSONServiceV2 = gql`
  query getTFIDBPageJSONV2 {
    getTFIDBPageJSONV2 {
      PK
      SK
      JSON {
        trendingSearchType
        trendingSearchFilter
        collectionID
        dynamicListID
        displayName
        limit
        UIComponentType
        viewMoreEn
        viewMoreTe
        viewMoreLinkEn
        viewMoreLinkTe
        movieListID
        type
        userPickedListTitle_En
        userPickedListTitle_Te
        sectionTitle_En
        sectionTitle_Te

        userPickedLists {
          userPickedListType
          userPickedListID
        }
      }
    }
  }
`

export const getMoviesCastAndCrew = gql`
  query($movieIDs: [String]!) {
    getMoviesCastAndCrew(movieIDs: $movieIDs) {
      items {
        PK
        SK
        personID
        name_En
        name_Te
        about_En
        about_Te
      }
    }
  }
`
export const getPointsOfMovieOrPerson = gql`
  query($contentType: pointsContentType!, $id: String!, $recordType: pointsTypeForMovieOrPerson!) {
    getPointsOfMovieOrPerson(contentType: $contentType, id: $id, recordType: $recordType) {
      points
    }
  }
`
export const getAllTopMoviesWebseriesPersonsByPoints = gql`
  query($limit: Int!, $recordType: pointsTypeForMovieOrPerson!) {
    getAllTopMoviesWebseriesPersonsByPoints(limit: $limit, recordType: $recordType) {
      topRecordsByPoints {
        trendingMovies {
          movieID
          name_En
          name_Te
          points
        }
        trendingWebseries {
          movieID
          name_En
          name_Te
          points
        }
        trendingPersons {
          personID
          name_En
          name_Te
          points
        }
      }
      manuallyUpdatedTrendingData {
        trendingMovies {
          movieID
          PK
          SK
        }
        trendingPersons {
          personID
        }
        trendingWebseries {
          movieID
        }
      }
    }
  }
`
export const getTfidbUserReports = gql`
  query getTfidbUserReports($fromDate: Int!, $toDate: Int!, $view: viewType!) {
    getTfidbUserReports(fromDate: $fromDate, toDate: $toDate, view: $view) {
      userReportInfo {
        year
        month
        day
        count
      }
    }
  }
`
export const getAutoSuggestionsForTags = gql`
  query getAutoSuggestionsForTags(
    $mode: tagMode!
    $contentType: tagContentTypes!
    $search: String!
    $from: Int!
    $limit: Int!
    $tagType: tagTypeAdminPanel
  ) {
    getAutoSuggestionsForTags(
      mode: $mode
      tagType: $tagType
      contentType: $contentType
      search: $search
      from: $from
      limit: $limit
    ) {
      total
      items {
        PK
        SK
        mode
        tagType
        title_En
        title_Te
        tagURL
        contentType
        description_En
        description_Te
        createdDate
        createdTime
        lastModifiedTime
      }
    }
  }
`
